<template>
  <div
    class="page-header align-items-start"
    style="font-size: 14px"
    :style="styleObject"
  >
    <span class="mask bg-white"></span>
    <div
      v-if="isLoadDone"
      class="container mw-100"
      style="padding-left: 0px; padding-right: 0px"
      @click="hideDiv($event)"
    >
      <!-- KSK052: the dining chip lives in the header and opens the dining popup. -->
      <Header
        :isCheckoutPage="true"
        :show-dining="enableRetailMode != 1 && !!branch.show_dining_option"
        :dining-switchable="canToggleDining"
        @change-dining="openDiningOption"
      ></Header>
      <div class="row">
        <div
          class="ksk-co__scroll"
          :class="{ 'ksk-co__scroll--more': enableRetailMode != 1 }"
          :style="footerHeight ? { '--ksk-co-bar-height': footerHeight + 'px' } : null"
        >
          <div class="card-body">
            <!-- KSK012: retail — staff banner + scan / search field -->
            <div class="search-container" v-if="enableRetailMode == 1">
              <div v-if="staffLogined || merchantLogo" class="ksk-co__staff">
                <img v-if="merchantLogo" :src="merchantLogo" alt="" class="ksk-co__staff-logo" />
                <div v-if="staffLogined" class="ksk-co__staff-text">
                  <div class="ksk-co__member-name">{{ $t("kiosk.checkout.welcomeStaff", { name: staffInfo.name }) }}</div>
                  <div class="ksk-co__member-id">
                    {{ $t("kiosk.checkout.staffLimit", { code: staffInfo?.code, amount: formatPrice(staffInfo.remaining_spending ?? 0) }) }}
                  </div>
                </div>
              </div>
              <label class="ksk-co__scan">
                <span class="material-icons-round">qr_code_scanner</span>
                <input
                  type="text"
                  name="fake_username"
                  class="d-none"
                  autocomplete="username"
                />
                <input
                  type="text"
                  class="search-input"
                  :placeholder="$t('kiosk.checkout.searchPlaceholder')"
                  v-model="searchKeyword"
                  @keyup.enter="searchItem"
                />
                <span class="material-icons-round ksk-co__scan-search">search</span>
              </label>
            </div>

            <!-- KSK010: title -->
            <template v-if="enableRetailMode != 1">
              <div class="ksk-co__title-row">
                <div class="ksk-co__title-main">
                  <h1 class="ksk-co__title">{{ $t("kiosk.checkout.yourOrder") }}</h1>
                  <span class="ksk-co__title-count">
                    {{ $t(calculateTotalQuantity() === 1 ? "kiosk.common.itemOne" : "kiosk.common.itemMany", { count: calculateTotalQuantity() }) }}
                  </span>
                </div>
                <span v-if="branch.waiting_time_text" class="ksk-co__wait">
                  <span class="material-icons-round">schedule</span>
                  {{ $t("kiosk.checkout.waitingTime") }}
                  <strong>{{ branch.waiting_time_text }}</strong>
                </span>
              </div>
            </template>

            <!-- KSK010: cart line items -->
            <div class="ksk-co__list" :class="{ 'ksk-co__list--empty': !itemSelect || !itemSelect.length }">
              <div
                v-for="(item, index) in itemSelect"
                :key="index"
                class="ksk-line"
                :class="{
                  'ksk-line--na': item.isCanGet == 1,
                  'ksk-line--free': item.is_free_item,
                }"
              >
                <img :src="item.image" alt="" class="ksk-line__img" />
                <div class="ksk-line__body">
                  <!-- KSK065: only the line's final price (right column); no unit price. -->
                  <div class="ksk-line__name">{{ tName(item.item_name) }}</div>
                  <div class="ksk-line__tags">
                    <span v-if="item.is_free_item" class="ksk-line__pill ksk-line__pill--free">{{ $t("kiosk.checkout.free") }}</span>
                    <span
                      v-if="isEnableBcrs && parseInt(item.eligible_bcrs) === 1"
                      class="ksk-line__pill ksk-line__pill--bcrs"
                      >BCRS</span
                    >
                    <span v-if="item.isCanGet == 1" class="ksk-line__na">{{ $t("kiosk.common.notAvailable") }}</span>
                    <span v-if="priceUpdateOf(item)" class="ksk-line__pill ksk-line__pill--repriced">{{
                      $t("kiosk.checkout.priceUpdatedLine", { from: "$" + priceUpdateOf(item).from.toFixed(2), to: "$" + priceUpdateOf(item).to.toFixed(2) })
                    }}</span>
                  </div>
                  <template v-if="item.choice && item.choice_selected">
                    <template
                      v-for="(itemChoice, indexChoice) in item.choice_selected.items"
                      :key="indexChoice"
                    >
                      <div v-if="itemChoice.item_detail" class="ksk-line__choice">
                        <div class="ksk-line__choice-name">
                          {{ itemChoice.qty + " x " + tName(itemChoice.item_detail.item_name) }}
                          <span
                            v-if="isEnableBcrs && parseInt(itemChoice.item_detail.eligible_bcrs) === 1"
                            class="ksk-line__pill ksk-line__pill--bcrs"
                            >BCRS</span
                          >
                          <span v-if="getSubCategoryItemPrice(itemChoice)" class="ksk-line__base">{{
                            getSubCategoryItemPrice(itemChoice)
                          }}</span>
                        </div>
                        <KskCartModifiers
                          :groups="itemChoice.item_detail.modifier_group"
                          :show-bcrs="isEnableBcrs"
                          :price="getModifierSubTotal"
                          stacked
                        />
                      </div>
                    </template>
                  </template>
                  <KskCartModifiers
                    v-else
                    :groups="item.modifier_group"
                    :show-bcrs="isEnableBcrs"
                    :price="getModifierSubTotal"
                    stacked
                  />
                  <!-- KSK048: Edit lives under the item so it no longer pushes the price column. -->
                  <button
                    v-if="
                      branch &&
                      branch.show_edit_item_btn_in_cart_on_kiosk &&
                      ((item.choice && item.choice_selected) ||
                        (item.modifier_group && item.modifier_group.length > 0))
                    "
                    type="button"
                    class="ksk-line__edit"
                    :disabled="item.isCanGet == 1 || item.is_free_item"
                    @click="editCartItem(item, index)"
                  >
                    <span class="material-icons-round">edit</span>
                    {{ $t("kiosk.checkout.edit") }}
                  </button>
                </div>
                <div
                  class="ksk-line__price"
                  :class="{
                    'ksk-line__price--applied':
                      itemVoucherApplied.includes(item.id) ||
                      item.is_free_item ||
                      isPromoCodeApplied,
                  }"
                >
                  <!-- KSK119: usual price struck through above a Special Scheduled Price. -->
                  <div v-if="scheduleRegularLinePrice(item)" class="ksk-line__was">{{ scheduleRegularLinePrice(item) }}</div>
                  <div class="ksk-line__total">{{ getMainItemPriceAndModifiersPrice(item) }}</div>
                </div>
                <div class="ksk-line__actions">
                  <KskStepper
                    :model-value="item.quantity"
                    :min="0"
                    :disabled="item.is_free_item || item.isCanGet == 1"
                    @decrement="handleQuantityForMainItem(item, 1, index)"
                    @increment="handleQuantityForMainItem(item, 2, index)"
                  />
                </div>
              </div>
            </div>

            <template v-if="enableRetailMode != 1">
              <!-- Popular Add-Ons (was the upsell popup on the Order page) -->
              <section v-if="upsellItems.length" class="ksk-co__addons">
                <h2 class="ksk-co__section-title">{{ $t("kiosk.checkout.popularAddOns") }}</h2>
                <div class="ksk-co__addons-list">
                  <button
                    v-for="row in upsellItems"
                    :key="row.id"
                    type="button"
                    class="ksk-addon"
                    @click="addUpsellItem(row)"
                  >
                    <span class="ksk-addon__img-wrap">
                      <img v-if="row.item.image" :src="row.item.image" alt="" class="ksk-addon__img" />
                      <span v-else class="ksk-addon__img ksk-addon__img--empty material-icons-round">restaurant</span>
                      <span class="ksk-addon__plus material-icons-round">add</span>
                    </span>
                    <span class="ksk-addon__name">{{ tName(row.item.item_name) }}</span>
                    <span v-if="upsellPrice(row) > 0" class="ksk-addon__price">
                      $ {{ upsellPrice(row).toFixed(2) }}
                    </span>
                  </button>
                </div>
              </section>

              <!-- One summary card, read top to bottom: offers → charges → total
                   (was KSK052's offers | breakdown halves). -->
            </template>

            <!-- KSK012: retail applied offers / dining / bill (same rows as before) -->
            <template v-else>
              <section
                v-if="(rewardSelect && rewardSelect.length > 0) || isPromoCodeApplied"
                class="ksk-co__card"
              >
                <div v-if="rewardSelect && rewardSelect.length > 0" class="ksk-co__applied">
                  <span class="ksk-co__applied-icon material-icons-round">percent</span>
                  <span class="ksk-co__applied-text">{{ $t("kiosk.checkout.voucherApplied", { title: rewardSelect[0].reward_title }) }}</span>
                  <button type="button" class="ksk-co__remove" @click="removeVoucher">{{ $t("kiosk.common.remove") }}</button>
                </div>
                <div v-if="isPromoCodeApplied" class="ksk-co__applied">
                  <span class="ksk-co__applied-icon material-icons-round">check</span>
                  <span class="ksk-co__applied-text">{{ $t("kiosk.checkout.promoApplied", { name: promoCodeApplied.promo_name }) }}</span>
                  <button type="button" class="ksk-co__remove" @click="removePromoCode">{{ $t("kiosk.common.remove") }}</button>
                </div>
              </section>
              <!-- KSK048: retail always offers both options, so the chip always toggles. -->
              <div v-if="branch.show_dining_option && diningLabel" class="ksk-co__dining-row">
                <KskChip
                  variant="chip"
                  :icon="takeAwayOrDineIn == TAKE_AWAY ? 'takeout_dining' : 'restaurant'"
                  selected
                  interactive
                  :aria-label="$t('kiosk.checkout.switchDiningAria')"
                  @click="changeDiningOption(takeAwayOrDineIn == TAKE_AWAY ? DINE_IN : TAKE_AWAY)"
                >
                  {{ diningLabel }}
                  <span class="material-icons-round ksk-co__dining-swap">swap_horiz</span>
                </KskChip>
              </div>
            </template>
          </div>
        </div>
        <div ref="footer" class="footer col-12 ksk-co__footer">
          <!-- KSK091: short Order More pill centred on top of the footer sheet.
               KSK065: theme-colour outline + text on white, same as Start Over. -->
          <KskButton
            v-if="enableRetailMode != 1"
            variant="outlined"
            size="md"
            icon="add_circle_outline"
            class="ksk-co__more"
            @click="orderMore()"
          >
            {{ $t("kiosk.checkout.orderMore") }}
          </KskButton>
          <!-- Summary lives in the fixed footer (with Start Over / Payment), so
               the bill is always in view and only the items scroll. -->
          <section v-if="enableRetailMode != 1" class="ksk-co__summary" :aria-label="$t('kiosk.checkout.orderSummaryAria')">
            <!-- Two columns: offers on the left, charges + total on the right. -->
            <div class="ksk-co__summary-left" :class="{ 'ksk-co__summary-left--top': !memberInfo }">
            <div v-if="isPromoCodeApplied" class="ksk-co__applied">
              <span class="ksk-co__applied-icon material-icons-round">check</span>
              <span class="ksk-co__applied-text">{{ $t("kiosk.checkout.promoApplied", { name: promoCodeApplied.promo_name }) }}</span>
              <button type="button" class="ksk-co__remove" @click="removePromoCode">{{ $t("kiosk.common.remove") }}</button>
            </div>
            <div v-if="rewardSelect && rewardSelect.length > 0" class="ksk-co__applied">
              <span class="ksk-co__applied-icon material-icons-round">percent</span>
              <span class="ksk-co__applied-text">{{ $t("kiosk.checkout.voucherApplied", { title: rewardSelect[0].reward_title }) }}</span>
              <button type="button" class="ksk-co__remove" @click="removeVoucher">{{ $t("kiosk.common.remove") }}</button>
            </div>
            <div class="ksk-co__summary-offers">
              <button type="button" class="ksk-co__offer" @click="showPromoCodeModal()">
                <span class="material-icons-round">confirmation_number</span>
                <span class="ksk-co__offer-label">{{ $t("kiosk.checkout.promoCode") }}</span>
                <span class="material-icons-round ksk-co__chevron">chevron_right</span>
              </button>
              <button
                v-if="memberInfo && !isPromoCodeApplied"
                type="button"
                class="ksk-co__offer"
                :disabled="totalReward == 0"
                @click="gotoMyRewardPageKiosk()"
              >
                <span class="material-icons-round">redeem</span>
                <span class="ksk-co__offer-label">{{ $t("kiosk.checkout.rewards") }}</span>
                <span class="ksk-co__count">{{ totalReward }}</span>
                <span class="material-icons-round ksk-co__chevron">chevron_right</span>
              </button>
            </div>
            </div>

            <!-- KSK011: bill rows -->
            <div class="ksk-co__bill">
            <div class="ksk-co__bill-row">
              <span>{{ $t("kiosk.checkout.subtotal") }}</span>
              <span v-if="payLoad">...</span>
              <span v-else>$ {{ calculateTotal().toFixed(2) }}</span>
            </div>
            <!-- KSK118: what the struck-through (special) prices save, under the subtotal.
                 Informational only - the subtotal is already at the lower prices. -->
            <div class="ksk-co__bill-row ksk-co__bill-row--discount ksk-co__bill-row--savings" v-if="scheduleSavings >= 0.005">
              <span><span class="material-icons-round">savings</span>{{ $t("kiosk.checkout.youSaved") }}</span>
              <span>{{ formatPrice(scheduleSavings) }}</span>
            </div>
            <div class="ksk-co__bill-row" v-if="takeAwayOrDineIn == 2 && branch.service_charge_rate > 0">
              <span>{{ $t("kiosk.checkout.serviceCharge") }}</span>
              <span v-if="payLoad">...</span>
              <span v-else>$ {{ totalDineInFee().toFixed(2) }}</span>
            </div>
            <div class="ksk-co__bill-row" v-if="convertedValueGstRate() > 0 && Math.abs(branch.gst_rate) != 0">
              <span>{{ $t("kiosk.checkout.gst", { rate: Math.abs(branch.gst_rate) }) }}</span>
              <span v-if="payLoad">...</span>
              <span v-else>$ {{ convertedValueGstRate().toFixed(2) }}</span>
            </div>
            <div class="ksk-co__bill-row" v-if="convertedValueGstRate() == 0 && Math.abs(branch.gst_rate) != 0">
              <span>{{ $t("kiosk.checkout.gst", { rate: Math.abs(branch.gst_rate) }) }}</span>
              <span v-if="payLoad">...</span>
              <span v-else>$ {{ finalTotal() == 0 ? '0.00' : totalGSTInclusive().toFixed(2) }}</span>
            </div>
            <div class="ksk-co__bill-row" v-if="isEnableBcrs && totalBcrs > 0">
              <span>{{ $t("kiosk.checkout.bcrsDeposit", { count: parseInt(totalBcrs / branch.each_bcrs_amount), amount: branch.each_bcrs_amount }) }}</span>
              <span v-if="payLoad">...</span>
              <span v-else>$ {{ totalBcrs.toFixed(2) }}</span>
            </div>
            <!-- Discounts last, right above the total, highlighted (display
                 order only; the amounts are computed as before). -->
            <div class="ksk-co__bill-row ksk-co__bill-row--discount" v-if="rewardSelect && rewardSelect.length > 0">
              <span><span class="material-icons-round">local_offer</span>{{ $t("kiosk.checkout.voucherDiscount") }}</span>
              <span v-if="payLoad">...</span>
              <span v-else class="ksk-co__discount">
                <template v-if="rewardSelect[0].reward_type == freeItem">{{ $t("kiosk.checkout.freeItem") }}</template>
                <template v-else>{{ voucher_deducted_format ? '-' + voucher_deducted_format : '-$ 0.00' }}</template>
              </span>
            </div>
            <div class="ksk-co__bill-row ksk-co__bill-row--discount" v-if="isPromoCodeApplied">
              <span><span class="material-icons-round">local_offer</span>{{ $t("kiosk.checkout.promoCodeDiscount") }}</span>
              <span class="ksk-co__discount">{{
                getPromoDiscountAmount()
                  ? "-$ " + getPromoDiscountAmount().toFixed(2)
                  : "-$ 0.00"
              }}</span>
            </div>
            <div class="ksk-co__bill-total">
              <!-- Item count is next to the "Your Order" title. -->
              <span class="ksk-co__bill-total-label">{{ $t("kiosk.checkout.totalPayable") }}</span>
              <span v-if="payLoad" class="ksk-co__bill-total-amount">...</span>
              <span v-else class="ksk-co__bill-total-amount">$ {{ totalPayable() }}</span>
            </div>
            <!-- KSK048: guest nudge — only when the cart actually has member prices. -->
            <button
              v-if="canSignInToSave"
              type="button"
              class="ksk-co__save"
              @click="onMembershipSignIn"
            >
              <span class="material-icons-round">stars</span>
              <!-- KSK119: special prices already save the guest something - say so first. -->
              <span v-if="canShowScheduleSaved" class="ksk-co__save-text">
                {{ $t("kiosk.checkout.specialSaveBefore") + " " }}<strong>{{ formatPrice(scheduleSavings) }}</strong> {{ $t("kiosk.checkout.specialSaveShortAfter") }}
                · {{ $t("kiosk.checkout.signInSaveMoreBefore") + " " }}<strong>{{ formatPrice(memberSavings) }}</strong> {{ $t("kiosk.checkout.signInSaveMoreAfter") }}
              </span>
              <span v-else class="ksk-co__save-text">
                {{ $t("kiosk.checkout.signInToSaveBefore") + " " }}<strong>{{ formatPrice(memberSavings) }}</strong> {{ $t("kiosk.checkout.signInToSaveAfter") }}
              </span>
              <span class="material-icons-round ksk-co__chevron">chevron_right</span>
            </button>
            <!-- KSK107: the same pill once signed in, telling what the member saves. -->
            <div v-else-if="canShowSaved" class="ksk-co__save ksk-co__save--saved">
              <span class="material-icons-round">stars</span>
              <span class="ksk-co__save-text">
                {{ $t("kiosk.checkout.youSave") + " " }}<strong>{{ formatPrice(savedAmount) }}</strong> {{ $t("kiosk.checkout.youSaveAfter") }}
              </span>
            </div>
            <!-- KSK119: a guest whose cart only saves through special prices. -->
            <div v-else-if="canShowScheduleSaved" class="ksk-co__save ksk-co__save--saved">
              <span class="material-icons-round">stars</span>
              <span class="ksk-co__save-text">
                {{ $t("kiosk.checkout.specialSaveBefore") + " " }}<strong>{{ formatPrice(scheduleSavings) }}</strong> {{ $t("kiosk.checkout.specialSaveAfter") }}
              </span>
            </div>
            </div>
          </section>
          <!-- KSK111: retail bill in the fixed footer, full width, styled like the
               non-retail summary (discount last, highlighted; no title). -->
          <section v-if="enableRetailMode == 1" class="ksk-co__summary ksk-co__summary--retail" :aria-label="$t('kiosk.checkout.orderSummaryAria')">
            <div class="ksk-co__bill">
            <div class="ksk-co__bill-row">
              <span>{{ $t("kiosk.checkout.subtotal") }}</span>
              <span v-if="payLoad">...</span>
              <span v-else>$ {{ calculateTotal().toFixed(2) }}</span>
            </div>
            <div class="ksk-co__bill-row" v-if="takeAwayOrDineIn == 2 && branch.service_charge_rate > 0">
              <span>{{ $t("kiosk.checkout.serviceChargeRate", { rate: branch.service_charge_rate }) }}</span>
              <span v-if="payLoad">...</span>
              <span v-else>$ {{ totalDineInFee().toFixed(2) }}</span>
            </div>
            <div class="ksk-co__bill-row" v-if="convertedValueGstRate() > 0 && Math.abs(branch.gst_rate) != 0">
              <span>{{ $t("kiosk.checkout.gst", { rate: Math.abs(branch.gst_rate) }) }}</span>
              <span v-if="payLoad">...</span>
              <span v-else>$ {{ convertedValueGstRate().toFixed(2) }}</span>
            </div>
            <div class="ksk-co__bill-row" v-if="convertedValueGstRate() == 0 && Math.abs(branch.gst_rate) != 0">
              <span>{{ $t("kiosk.checkout.gst", { rate: Math.abs(branch.gst_rate) }) }}</span>
              <span v-if="payLoad">...</span>
              <span v-else>$ {{ finalTotal() == 0 ? '0.00' : totalGSTInclusive().toFixed(2) }}</span>
            </div>
            <div class="ksk-co__bill-row" v-if="isEnableBcrs && totalBcrs > 0">
              <span>{{ $t("kiosk.checkout.bcrsDeposit", { count: parseInt(totalBcrs / branch.each_bcrs_amount), amount: branch.each_bcrs_amount }) }}</span>
              <span v-if="payLoad">...</span>
              <span v-else>$ {{ totalBcrs.toFixed(2) }}</span>
            </div>
            <div class="ksk-co__bill-row ksk-co__bill-row--discount" v-if="rewardSelect && rewardSelect.length > 0">
              <span><span class="material-icons-round">local_offer</span>{{ $t("kiosk.checkout.voucherDiscount") }}</span>
              <span v-if="payLoad">...</span>
              <span v-else class="ksk-co__discount">
                <template v-if="rewardSelect[0].reward_type == freeItem">{{ $t("kiosk.checkout.freeItem") }}</template>
                <template v-else>{{ voucher_deducted_format ? '-' + voucher_deducted_format : '-$ 0.00' }}</template>
              </span>
            </div>
            <div class="ksk-co__bill-total">
              <span class="ksk-co__bill-total-label">{{ $t("kiosk.checkout.totalPayable") }}</span>
              <span v-if="payLoad" class="ksk-co__bill-total-amount">...</span>
              <span v-else class="ksk-co__bill-total-amount">$ {{ totalPayable() }}</span>
            </div>
            </div>
          </section>
          <div class="ksk-co__bar">
            <!-- KSK048: Start Over bottom-left like the other kiosk pages. The total
                 is in the summary right above; retail has no summary in the
                 footer, so there the Payment button still carries it. -->
            <!-- KSK091: Start Over + Payment share one row in both modes; Order
                 More floats above the footer sheet instead. -->
            <div class="ksk-co__bar-main">
              <KskButton
                variant="outlined"
                size="md"
                icon="restart_alt"
                class="ksk-co__start-over"
                :disabled="enableRetailMode != 1 && (!itemSelect || itemSelect.length == 0)"
                @click="confirmStartOver()"
              >
                {{ $t("kiosk.footer.startOver") }}
              </KskButton>
              <KskButton
                class="ksk-co__pay"
                size="md"
                :disabled="!itemSelect || itemSelect.length == 0"
                @click="proccedToPayment()"
              >
                {{ $t("kiosk.checkout.payment") }}<template v-if="enableRetailMode == 1 && !payLoad && itemSelect && itemSelect.length"> · $ {{ totalPayable() }}</template>
              </KskButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-2 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading :active="loaderActive" />
  </div>
  <ModalSignInNew></ModalSignInNew>
  <!-- KSK110: retail staff sign-in from the header chip. -->
  <ModalStaffSignIn :keyReload="keyReloadStaffSignIn"></ModalStaffSignIn>
  <ModalNotification
    :message="txtNotification"
    :closeModalNotificationHandler="closeModalNotificationHandler"
    :onChangeSearchKeyword="onChangeSearchKeyword"
    :isKiosk="true"
  />
  <ModalConfirm
    :message="txtConfirm"
    :ksk-preset="kskConfirmPreset"
    :process-yes="processYes"
    :isKiosk="true"
  />
  <ModalNotificationOutStockItems :itemSelect="itemSelect" :isKiosk="true" />
  <ModalPricesUpdated ref="pricesUpdatedModal" :items="pricesUpdatedLines" :isKiosk="true" />
  <ModalConfirmPinCode
    :keyReload="keyReloadModalConfirmPinCode"
    @confirmPinCode="confirmPinCode"
  />
  <ModalConfirmStillThere
    :keyReload="keyReloadModalConfirmStillThere"
    :continueMyOrder="continueMyOrder"
    :resetNow="resetNow"
  />
  <ModalConfirmPasscode
    :keyReload="keyReloadModalConfirmPasscode"
    @confirmPasscode="confirmPasscode"
  />
  <ModalSelectDiningOption
    v-if="isLoadDone && enableRetailMode != 1 && branch.show_dining_option"
    :diningLocation="Number(branch.dining_location) || 0"
    :selectDiningOption="onPickDiningOption"
    :selected="takeAwayOrDineIn ? Number(takeAwayOrDineIn) : null"
    :dismissible="true"
  />
  <ModalPromoCode ref="modalPromoCode" @apply-promo-code="handleApplyPromoCode" />
  <ModalItemDetail
    :categoryId="categoryIdSelect"
    :itemId="itemIdSelect"
    :itemDetail="itemDetail"
    :isLogined="isLogined || staffLogined"
    :reloadModal="reloadModal"
    :editMode="editItemIndex >= 0"
    :editItemIndex="editItemIndex"
    @clear-data-item="clearDataItem"
    @item-updated="handleItemUpdated"
  />
  <ModalInputBuzzerNumber
    :keyReload="keyReloadModalInputBuzzerNumber"
    :inputBuzzerNumber="inputBuzzerNumber"
    :buzzerNumberText="buzzerNumberText"
  />
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import $ from "jquery";
import PromocodeService from "../../services/promocode.service";
import OrderService from "../../services/order.service";
import { applyCartPrices, carryRepricedLines } from "@/config/cartPrices";
import ModalNotification from "@/components/ModalNotification.vue";
import ModalPricesUpdated from "@/components/ModalPricesUpdated.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import ModalNotificationOutStockItems from "@/components/ModalNotificationOutStockItems.vue";
import ModalConfirmPinCode from "../kiosk/components/ModalConfirmPinCode.vue";
import EventBus from "vue3-eventbus";
import confetti from "canvas-confetti";
import { localStorageName, getDiningOption, getCartItemIndexesInvalidForDiningOption } from "@/config/utils";
import Header from "../kiosk/components/Header.vue";
import ModalSelectDiningOption from "../kiosk/components/ModalSelectDiningOption.vue";
import KioskService from "../../services/kiosk.service";
import ModalConfirmStillThere from "../kiosk/components/ModalConfirmStillThere.vue";
import ModalSignInNew from "../kiosk/components/ModalSignInNew.vue";
import ModalStaffSignIn from "../kiosk/components/ModalStaffSignIn.vue";
import memberService from "../../services/member.service";
import { FREE_ITEM, TAKE_AWAY, DINE_IN, isPromoCodeError } from "@/config/const";
import { promoDiscountAmount, promoRemovedMessage, promoReasonText } from "@/config/promoCode";
import ModalConfirmPasscode from "../kiosk/components/ModalConfirmPasscode.vue";
import ModalPromoCode from "../kiosk/components/ModalPromoCode.vue";
import ModalItemDetail from "../kiosk/components/ModalItemDetail.vue";
import ModalInputBuzzerNumber from "../kiosk/components/ModalInputBuzzerNumber.vue";
import KskButton from "./components/ui/KskButton.vue";
import KskChip from "./components/ui/KskChip.vue";
import KskStepper from "./components/ui/KskStepper.vue";
import KskCartModifiers from "./components/KskCartModifiers.vue";
import { isKioskPreview } from "@/views/kiosk/kioskPreview";
import { collectNamesDeep, syncMenuTranslations, translatedName } from "@/i18n/menuTranslate";

export default {
  name: "Checkout",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    ModalNotification,
    ModalPricesUpdated,
    ModalNotificationOutStockItems,
    ModalConfirmPinCode,
    Header,
    ModalConfirm,
    ModalSelectDiningOption,
    ModalConfirmStillThere,
    ModalSignInNew,
    ModalStaffSignIn,
    ModalConfirmPasscode,
    ModalPromoCode,
    ModalItemDetail,
    ModalInputBuzzerNumber,
    KskButton,
    KskChip,
    KskStepper,
    KskCartModifiers,
  },
  data() {
    return {
      // Height of the fixed footer (summary + buttons); the scroll area stops
      // above it. Measured, since the summary grows with promo / BCRS rows.
      footerHeight: 0,
      isLoadDone: false,
      snackbar: null,
      error: "",
      paymentMethod: "",
      branch: JSON.parse(
        localStorage.getItem(localStorageName("BRANCH_INFO"), "")
      ),
      cutleryChecked: true,
      memberInfo: JSON.parse(
        localStorage.getItem(localStorageName("KIOSK_MEMBER_INFO"), "")
      ),
      memberId: 0,
      loaderActive: false,
      myRewardData: [],
      selectedItem: null,
      selectVoucher: false,
      itemSelect: [],
      rewardSelect: JSON.parse(
        localStorage.getItem(localStorageName("SELECTED_REWARD"), [])
      ),
      take_away_fee: 0,
      openBoxMintyWallet: true,
      totalVoucherDiscount: 0,
      voucher_deducted_format: "",
      isLogined: false,
      isCanPay: 1,
      cartName: "ORDER_INFO",
      txtNotification: "",
      // Price Schedules: lines just repriced by applyReloadPrices, highlighted while on this screen.
      repricedLines: [],
      pricesUpdatedLines: [],
      MERCHANT_BRAND_NAME: "",
      payLoad: false,
      merchantCode: "",
      branchCode: "",
      guest: localStorage.getItem(localStorageName("NUMBER_OF_GUESTS")) ?? 0,
      showCartUpdatedAfterClearItemsOutStock: false,
      stopOrdering: 0,
      itemIndexSelected: -1,
      takeAwayOrDineIn:
        localStorage.getItem(localStorageName("DINING_OPTION")) ?? 2,
      enableRetailMode: 0,
      searchKeyword: "",
      searchTimerId: null,
      keyReloadModalConfirmPinCode: "keyReloadModalConfirmPinCode",
      timeOutNotification: null,
      pincodePassed: false,
      pincodePassedTimeout: null,
      keyReloadModalConfirmStillThere: "keyReloadModalConfirmStillThere",
      isIdle: false,
      idleTime: 0,
      idleInterval: null,
      lastActivity: Date.now(),
      merchantLogo:
        localStorage.getItem(localStorageName("MERCHANT_LOGO")) ?? "",
      staffInfo: JSON.parse(
        localStorage.getItem(localStorageName("STAFF_INFO"), "")
      ),
      staffLogined: false,
      freeItem: FREE_ITEM,
      TAKE_AWAY: TAKE_AWAY,
      DINE_IN: DINE_IN,
      itemVoucherApplied: [],
      requirePasscodeEntryToRedeemVouchers: 0,
      keyReloadModalConfirmPasscode: "keyReloadModalConfirmPasscode",
      keyReloadStaffSignIn: "keyReloadStaffSignIn",
      txtConfirm: "",
      kskConfirmPreset: "",
      confirmType: 0,
      pendingDiningOption: null,
      pendingRemoveIndex: -1,
      isPromoCodeApplied: false,
      promoCodeApplied: null,
      categoryIdSelect: 0,
      itemIdSelect: 0,
      itemDetail: {},
      reloadModal: 'reload-item-detail',
      editItemIndex: -1,
      isEnableBcrs: 0,
      buzzerNumber: "",
      showBuzzerNumber: 0,
      buzzerNumberText: "",
      keyReloadModalInputBuzzerNumber: "keyReloadModalInputBuzzerNumber",
      // KSK011: "Rewards (n)" row, moved here from the checkout header.
      totalReward: 0,
      // Popular Add-Ons (replaces the Order-page upsell popup).
      upsellItems: [],
      addingUpsellItem: false,
    };
  },
  async created() {
    this.cartName = await this.$store.dispatch("cartName");
    this.merchantCode = this.$store.state.merchantCode;
    this.branchCode = this.$store.state.branchCode;
    this.itemSelect = JSON.parse(localStorage.getItem(this.cartName) || "[]");
    this.enableRetailMode =
      localStorage.getItem(localStorageName("KIOSK_MODE")) ?? 0;
    localStorage.removeItem(localStorageName("PAYMENT_METHOD"));
    this.requirePasscodeEntryToRedeemVouchers =
      this.branch.require_passcode_entry_to_redeem_vouchers ?? 0;

    if (this.memberInfo) {
      this.memberId = this.memberInfo.id ?? 0;
      this.isLogined = true;
      this.getTotalReward();
    }

    if (this.enableRetailMode && this.staffInfo) {
      this.staffLogined = true;
      await this.getStaffRemainingSpending();
    }

    if (this.enableRetailMode == 1) {
      if (this.itemSelect && this.itemSelect.length > 0) {
        // Filter out items that have modifiers
        this.itemSelect = this.itemSelect.filter((item) => {
          // Check if item has modifier groups
          if (item.modifier_group && item.modifier_group.length > 0) {
            return false;
          }

          // Check if item has choices with modifiers
          if (item.choice && item.choice_selected) {
            for (let choice of item.choice_selected.items) {
              if (
                choice.item_detail.modifier_group &&
                choice.item_detail.modifier_group.length > 0
              ) {
                return false;
              }
            }
          }

          return true;
        });

        // Update cart in localStorage
        localStorage.setItem(this.cartName, JSON.stringify(this.itemSelect));
      }
    }

    // Load promo code from localStorage if exists
    const savedPromoCode = localStorage.getItem(localStorageName("KIOSK_PROMO_CODE_APPLIED"));
    if (savedPromoCode) {
      try {
        const promoData = JSON.parse(savedPromoCode);
        // Keep the saved code on the cart, then re-validate it: a code that can no longer be
        // used is dropped with a modal saying why, any other failure leaves it as it is.
        this.promoCodeApplied = promoData;
        this.isPromoCodeApplied = true;
        this.handleApplyPromoCode(promoData.promo_code, true);
      } catch (error) {
        console.error("Error parsing saved promo code");
        // Clear invalid data
        localStorage.removeItem(localStorageName("KIOSK_PROMO_CODE_APPLIED"));
      }
    }

    // Sent back by PaymentSelection because the promo code was refused at payment: say why here,
    // over the cart and its new total.
    const removedPromo = localStorage.getItem(localStorageName("KIOSK_PROMO_CODE_REMOVED"));
    if (removedPromo) {
      localStorage.removeItem(localStorageName("KIOSK_PROMO_CODE_REMOVED"));
      try {
        const notice = JSON.parse(removedPromo);
        this.onPromoCodeUnavailable(notice.reason, notice.code);
      } catch (error) {
        console.error("Error parsing removed promo code notice");
      }
    }

    this.isEnableBcrs = parseInt(this.branch?.enable_bcrs) ?? 0;

    this.reloadOrder();
    this.isLoadDone = true;

    if (this.enableRetailMode != 1) {
      this.loadUpsells();
    }
  },
  mounted() {
    $(".modal-backdrop.fade.show").remove();

    this.observeFooter();
    
    setTimeout(
      () => {
        if (this.enableRetailMode == 1) {
          // Keeps the barcode field focused, but not while a popup is open: staff
          // sign-in (KSK110) keeps its own input focused and would lose keystrokes.
          this.retailFocusTimer = setInterval(() => {
            if (!document.querySelector(".modal.show")) $(".search-input").focus();
          }, 100);
        }

        if (this.memberInfo) {
          if (this.enableRetailMode == 1) {
            $(".row.retail-mode").css("margin-top", "142px");
          } else {
            $(".content").css("margin-top", "142px");
          }
        }

        if (this.enableRetailMode == 1) {
          $(".row.retail-mode").css("height", `calc(var(--ksk-vh, 1vh) * 100 - 182px)`);
        } else {
          this.recalculateLayout();
        }
      },
      this.enableRetailMode == 1 ? 100 : 500
    );

    // KSK051: named so beforeUnmount can remove them. A listener left behind
    // keeps running on the menu page: its LoginSuccess set the page-wide
    // `.content` margin-top: 142px on Order's item list (blank band after
    // signing in there).
    this.busHandlers = {
      ClearItemsOutStockSuccess: async () => {
        this.isCanPay = 1;
        this.showCartUpdatedAfterClearItemsOutStock = true;
      },
      Logout: () => {
        this.confirmLogout();
      },
      LoginSuccess: async () => {
        this.memberInfo = JSON.parse(
          localStorage.getItem(localStorageName("KIOSK_MEMBER_INFO")) || "null"
        );
        if (this.memberInfo) {
          this.memberId = this.memberInfo.id ?? 0;
          this.isLogined = true;
          this.getTotalReward();
        }
        // KSK110: staff signed in from the header chip.
        this.staffInfo = JSON.parse(
          localStorage.getItem(localStorageName("STAFF_INFO")) || "null"
        );
        if (this.enableRetailMode && this.staffInfo) {
          this.staffLogined = true;
          await this.getStaffRemainingSpending();
        }
        // Re-price the cart (member prices) and re-check voucher availability
        // without a full page reload.
        await this.reloadOrder();
        this.$nextTick(() => {
          if (this.enableRetailMode == 1) {
            $(".row.retail-mode").css("margin-top", "142px");
          } else {
            $(".content").css("margin-top", "142px");
            this.recalculateLayout();
          }
        });
      },
      ShowStaffSignIn: () => {
        this.keyReloadStaffSignIn = Math.random().toString();
        $(".btn-show-modal-staff-signin").click();
      },
      ShowModalConfirmPasscode: () => {
        this.keyReloadModalConfirmPasscode = Math.random().toString();
        $(".btn-show-modal-confirm-passcode").click();
      },
    };
    Object.entries(this.busHandlers).forEach(([event, handler]) => EventBus.on(event, handler));

    document
      .querySelector(".main-content")
      .addEventListener("mousemove", this.resetIdleTimer);
    document
      .querySelector(".main-content")
      .addEventListener("keypress", this.resetIdleTimer);
    document
      .querySelector(".main-content")
      .addEventListener("click", this.resetIdleTimer);
    document
      .querySelector(".main-content")
      .addEventListener("scroll", this.resetIdleTimer);

    this.startIdleTimer();
  },
  watch: {
    // The page (and its footer) renders once the async created() sets
    // isLoadDone, which is after mounted().
    isLoadDone(loaded) {
      if (loaded) this.$nextTick(() => this.observeFooter());
    },
    // KSK054: cart lines and add-ons may hold names the menu batch never
    // fetched (direct visit / refresh, retail scan) — fetch any still missing.
    itemSelect: {
      deep: true,
      handler() {
        this.syncCartNames();
      },
    },
    upsellItems() {
      this.syncCartNames();
    },
    // KSK096: language switched from the header — re-translate every line,
    // not only the missing ones (they still hold the previous locale).
    "$i18n.locale"() {
      syncMenuTranslations(collectNamesDeep([this.itemSelect, this.upsellItems]));
    },
  },
  beforeUnmount() {
    clearInterval(this.retailFocusTimer);
    Object.entries(this.busHandlers || {}).forEach(([event, handler]) => EventBus.off(event, handler));
    this.footerObserver?.disconnect();
    window.removeEventListener("popstate", this.clearIsEditQuantity());
    document
      .querySelector(".main-content")
      .removeEventListener("mousemove", this.resetIdleTimer);
    document
      .querySelector(".main-content")
      .removeEventListener("keypress", this.resetIdleTimer);
    document
      .querySelector(".main-content")
      .removeEventListener("click", this.resetIdleTimer);
    document
      .querySelector(".main-content")
      .removeEventListener("scroll", this.resetIdleTimer);
    clearInterval(this.idleInterval);
    this.idleInterval = null;
  },
  computed: {
    styleObject() {
      return {
        "--color": this.$store.state.color,
      };
    },
    diningLabel() {
      if (this.takeAwayOrDineIn == DINE_IN) return this.$t("kiosk.common.dineIn");
      if (this.takeAwayOrDineIn == TAKE_AWAY) return this.$t("kiosk.common.takeAway");
      return "";
    },
    canToggleDining() {
      return !!this.branch?.show_dining_option && this.branch?.dining_location == 0;
    },
    // KSK048: what a guest would save on this cart with member prices.
    memberSavings() {
      if (!this.itemSelect) return 0;
      return this.itemSelect.reduce((total, item) => {
        const regular = parseFloat(item.price_default) || 0;
        const member = parseFloat(item.member_price) || 0;
        if (member > 0 && member < regular) {
          total += (regular - member) * (parseInt(item.quantity) || 0);
        }
        return total;
      }, 0);
    },
    // KSK107: what a signed-in member saves on this cart through member prices - each line's
    // default price against the member price they pay. A Special Scheduled Price puts both on
    // the same price, so such a line adds nothing here; its saving is the "You saved" row
    // (scheduleSavings), so no saving is counted twice.
    savedAmount() {
      if (!this.itemSelect) return 0;
      return this.itemSelect.reduce((total, item) => {
        const paid = parseFloat(item.member_price) || parseFloat(item.price_default) || 0;
        const regular = parseFloat(item.price_default) || 0;
        if (paid > 0 && paid < regular) {
          total += (regular - paid) * (parseInt(item.quantity) || 0);
        }
        return total;
      }, 0);
    },
    canShowSaved() {
      return (
        (this.isLogined || this.staffLogined) &&
        !this.branch?.enable_retail_mode &&
        this.savedAmount >= 0.005
      );
    },
    // KSK119: what Special Scheduled Prices save on this cart against the usual prices
    // (order/reload's original_*_no_modifier_option) - the sum of the struck-through lines,
    // so a member is measured against their usual member price.
    scheduleSavings() {
      if (!this.itemSelect) return 0;
      return this.itemSelect.reduce(
        (total, item) => total + this.scheduleLineSaving(item) * (parseInt(item.quantity) || 0),
        0
      );
    },
    // KSK119: guests see the special-price saving too (members get it in savedAmount).
    canShowScheduleSaved() {
      return (
        !this.isLogined &&
        !this.staffLogined &&
        !this.branch?.enable_retail_mode &&
        this.scheduleSavings >= 0.005
      );
    },
    canSignInToSave() {
      return (
        !this.isLogined &&
        !this.staffLogined &&
        !!this.branch?.membership_on_kiosk &&
        !this.branch?.enable_retail_mode &&
        this.memberSavings > 0
      );
    },

    totalBcrs() {
      if (!this.isEnableBcrs) return 0;

      const eachBcrsAmount = parseFloat(this.branch && this.branch.each_bcrs_amount) || 0;
      if (eachBcrsAmount <= 0) return 0;

      if (!this.itemSelect || this.itemSelect.length === 0) return 0;

      let totalQty = 0;

      this.itemSelect.forEach((item) => {
        if (!item) return;
        if (item.is_delivery_fee_item) return;

        const mainQty = parseInt(item.quantity) || 0;
        if (mainQty <= 0) return;

        // Main item
        if (parseInt(item.eligible_bcrs) === 1) {
          totalQty += mainQty;
        }

        if (item.choice) {
          // Choice item
          if (item.choice_selected && item.choice_selected.items) {
            item.choice_selected.items.forEach((itemChoice) => {
              const choiceQty = parseInt(itemChoice.qty) || 0;
              if (choiceQty <= 0) return;

              // Choice item itself
              if (
                itemChoice.item_detail &&
                parseInt(itemChoice.item_detail.eligible_bcrs) === 1
              ) {
                totalQty += choiceQty * mainQty;
              }

              // Modifier group of choice item
              if (itemChoice.item_detail && itemChoice.item_detail.modifier_group) {
                itemChoice.item_detail.modifier_group.forEach((group) => {
                  if (!group.items) return;
                  group.items.forEach((itemModifier) => {
                    const modQty = parseInt(itemModifier.quantity) || 0;

                    if (parseInt(itemModifier.eligible_bcrs) === 1) {
                      totalQty += modQty * choiceQty * mainQty;
                    }

                    // Sub modifier of modifier group of choice item
                    if (
                      itemModifier.item_in_mog &&
                      itemModifier.item_in_mog.modifier_group
                    ) {
                      itemModifier.item_in_mog.modifier_group.forEach((subGroup) => {
                        if (!subGroup.items) return;
                        subGroup.items.forEach((subItemModifier) => {
                          const subModQty = parseInt(subItemModifier.quantity) || 0;
                          if (parseInt(subItemModifier.eligible_bcrs) === 1) {
                            totalQty += subModQty * modQty * choiceQty * mainQty;
                          }
                        });
                      });
                    }
                  });
                });
              }
            });
          }
        } else {
          // Modifier group of item without choice
          if (item.modifier_group) {
            item.modifier_group.forEach((group) => {
              if (!group.items) return;
              group.items.forEach((itemModifier) => {
                const modQty = parseInt(itemModifier.quantity) || 0;

                if (parseInt(itemModifier.eligible_bcrs) === 1) {
                  totalQty += modQty * mainQty;
                }

                // Sub modifier of modifier group of item without choice
                if (
                  itemModifier.item_in_mog &&
                  itemModifier.item_in_mog.modifier_group
                ) {
                  itemModifier.item_in_mog.modifier_group.forEach((subGroup) => {
                    if (!subGroup.items) return;
                    subGroup.items.forEach((subItemModifier) => {
                      const subModQty = parseInt(subItemModifier.quantity) || 0;
                      if (parseInt(subItemModifier.eligible_bcrs) === 1) {
                        totalQty += subModQty * modQty * mainQty;
                      }
                    });
                  });
                }
              });
            });
          }
        }
      });

      return totalQty * eachBcrsAmount;
    },
  },
  methods: {
    tName(source) {
      return translatedName(source);
    },

    syncCartNames() {
      if (this.$i18n.locale === "en") return;
      const missing = collectNamesDeep([this.itemSelect, this.upsellItems]).filter(
        (name) => translatedName(name) === name
      );
      if (missing.length) syncMenuTranslations(missing);
    },

    // Keep footerHeight in sync with the fixed footer (summary rows come and
    // go with promo / voucher / BCRS), so the scroll area ends right above it.
    observeFooter() {
      const footer = this.$refs.footer;
      if (!window.ResizeObserver || !footer || this.footerObserver) return;
      this.footerObserver = new ResizeObserver(() => {
        this.footerHeight = Math.ceil(this.$refs.footer?.offsetHeight || 0);
      });
      this.footerObserver.observe(footer);
    },
    formatPrice(price) {
      return "$ " + parseFloat(price).toFixed(2);
    },
    closeSnackbar() {
      this.snackbar = null;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    onChangeSearchKeyword(event) {
      this.searchKeyword = event.target.value;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(async () => {
        await this.searchItem();
      }, 500);
    },
    async searchItem() {
      this.showLoader();
      $(".btn-close-notification-modal").click();
      clearTimeout(this.timeOutNotification);
      this.timeOutNotification = null;
      let dataForm = {
        branch_code: this.branch.branch_code,
        barcode: this.searchKeyword,
      };

      await KioskService.searchItem(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const itemSearch = response.data.data;

            const objectInArrayIndex = this.itemSelect.findIndex((item) => {
              if (item.id == itemSearch.id) {
                item.quantity += itemSearch.quantity;
                return true;
              }
              return false;
            });

            if (objectInArrayIndex !== -1) {
              this.updateCartOrder();
            } else {
              this.itemSelect.push(itemSearch);
              this.updateCartOrder();
            }

            this.snackbar = "success";
            this.message = this.$t("kiosk.common.addedToCartSuccess");
            this.setTimeOutNotification();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          const errorMessage = error.response.data.result.message;

          if (errorMessage == "Item not found") {
            this.txtNotification = this.$t("kiosk.checkout.itemNotFound", { keyword: this.searchKeyword });
            $(".btn-notification-modal").click();

            this.timeOutNotification = setTimeout(() => {
              this.txtNotification = "";
              $(".btn-close-notification-modal").click();
            }, 5000);
          } else {
            this.snackbar = "danger";
            this.message = error.response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        }
      );

      this.searchKeyword = "";
    },
    // M977: whole bill, or only the items of the promo's report groups.
    promoDiscountFor(billSubtotal) {
      return promoDiscountAmount(
        this.promoCodeApplied,
        billSubtotal,
        this.itemSelect,
        this.isLogined || this.staffLogined
      );
    },
    calculateTotal() {
      if (this.itemSelect && this.itemSelect.length > 0) {
        return this.itemSelect.reduce((total, product) => {
          if (this.isLogined || this.staffLogined) {
            total += product.member_price
              ? product.member_price * product.quantity
              : 0;
          } else {
            total += product.price_default
              ? product.price_default * product.quantity
              : 0;
          }

          return total;
        }, 0);
      } else {
        return 0;
      }
    },
    calculateTotalQuantity() {
      if (this.itemSelect && this.itemSelect.length > 0) {
        return this.itemSelect.reduce((total, product) => {
          total += product.quantity;
          return total;
        }, 0);
      } else {
        return 0;
      }
    },
    finalTotal() {
      // if promo code applied, calculate with discount
      if (this.isPromoCodeApplied && this.promoCodeApplied) {
        return this.calculateFinalTotalWithPromoCode().toFixed(2);
      }
      // if no promo code, calculate normally
      return this.calculateTotalAfterGST().toFixed(2);
    },
    totalPayable() {
      const finalTotalNum = parseFloat(this.finalTotal()) || 0;
      const bcrsNum = parseFloat(this.totalBcrs) || 0;
      return (finalTotalNum + bcrsNum).toFixed(2);
    },
    calculateFinalTotalWithPromoCode() {
      if (!this.promoCodeApplied) {
        return this.calculateTotalAfterGST();
      }

      // Calculate base total (subtotal)
      let baseTotal = this.calculateTotal();

      // Calculate promo discount based on type
      let promoDiscount = 0;
      promoDiscount = this.promoDiscountFor(baseTotal);

      // Apply both voucher and promo discounts
      let finalAmount = baseTotal - this.totalVoucherDiscount - promoDiscount;

      // add service charge if there is
      if (this.takeAwayOrDineIn == 2 && this.branch.service_charge_rate > 0) {
        const serviceCharge = finalAmount * (this.branch.service_charge_rate / 100);
        finalAmount += serviceCharge;
      }

      // add tax if it is EXCLUSIVE (gst_rate > 0)
      const numericValue = parseFloat(this.branch.gst_rate);
      if (numericValue > 0) {
        const gstAmount = finalAmount * (numericValue / 100);
        finalAmount += gstAmount;
      }

      return finalAmount > 0 ? finalAmount : 0;
    },
    checkEnableVoucher() {
      if (this.rewardSelect && this.rewardSelect.length > 0) {
        if (this.rewardSelect[0].order_minimum == 2) {
          if (this.calculateTotal() < this.rewardSelect[0].order_total) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
      return false;
    },
    async calculateVoucherPrice() {
      this.showLoader();
      if (
        this.memberInfo &&
        this.rewardSelect &&
        this.rewardSelect.length > 0
      ) {
        // KSK065: set by MyReward when the reward was just picked; read once.
        const justApplied = !!localStorage.getItem(localStorageName("KIOSK_REWARD_JUST_APPLIED"));
        localStorage.removeItem(localStorageName("KIOSK_REWARD_JUST_APPLIED"));
        let dataForm = {
          branch_code: this.branch.branch_code,
          memberId: this.memberId,
          voucherCode: this.rewardSelect[0].code,
          totalOrder: this.calculateTotal(),
          items: this.itemSelect,
        };

        await PromocodeService.calculateVoucherPrice(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              if (this.rewardSelect[0].reward_type == FREE_ITEM) {
                if (this.rewardSelect[0].item_selected) {
                  this.itemSelect.push(this.rewardSelect[0].item_selected);
                }
                if (justApplied) this.celebrateRewardApplied();
              } else {
                this.voucher_deducted_format =
                  response.data.data.voucher_deducted_format;
                this.totalVoucherDiscount = response.data.data.voucher_deducted;
                this.itemVoucherApplied =
                  response.data.data.item_voucher_applied;
                const errMessage = response.data.data.error_message;

                if (errMessage) {
                  this.voucherError(errMessage);
                } else if (justApplied) {
                  this.celebrateRewardApplied();
                }
              }
            } else {
              this.voucherError(response.data.result.message);
            }
            this.hideLoader();
          },
          (error) => {
            this.voucherError(error.response.data.result.message);
            this.hideLoader();
          }
        );
      }
    },
    celebrateRewardApplied() {
      confetti({
        particleCount: 120,
        spread: 80,
        origin: { y: 0.6 },
        zIndex: 2000,
      });
    },
    totalDineInFee() {
      if (this.takeAwayOrDineIn == 2 && this.branch.service_charge_rate > 0) {
        // Calculate base amount for service charge
        let baseAmount = this.calculateTotal();

        // If promo code applied, calculate promo discount
        let promoDiscount = 0;
        if (this.isPromoCodeApplied && this.promoCodeApplied) {
          promoDiscount = this.promoDiscountFor(baseAmount);
        }

        // Apply both voucher and promo discounts
        baseAmount = baseAmount - this.totalVoucherDiscount - promoDiscount;

        return baseAmount * (this.branch.service_charge_rate / 100);
      } else {
        return 0;
      }
    },
    convertedValueGstRate() {
      const numericValue = parseFloat(this.branch.gst_rate);

      if (numericValue > 0) {
        // exclusive
        // Calculate base amount for GST
        let baseAmount = this.calculateTotal();

        // If promo code applied, calculate promo discount
        let promoDiscount = 0;
        if (this.isPromoCodeApplied && this.promoCodeApplied) {
          promoDiscount = this.promoDiscountFor(baseAmount);
        }

        // Apply both voucher and promo discounts
        baseAmount = baseAmount - this.totalVoucherDiscount - promoDiscount;

        // Add service charge to base amount for GST calculation
        baseAmount += this.totalDineInFee();

        // Round to 2 decimals so display and Bill Total stay consistent
        const rawGst = baseAmount * (numericValue / 100);
        return Math.round((rawGst + Number.EPSILON) * 100) / 100;
      } else {
        // inclusive
        return 0;
      }
    },
    calculateTotalAfterGST() {
      if (this.itemSelect && this.itemSelect.length > 0) {
        if (parseFloat(this.branch.gst_rate) < 0) {
          // INCLUSIVE
          let total = this.itemSelect.reduce((total, product) => {
            if (this.isLogined || this.staffLogined) {
              total += product.member_price
                ? product.member_price * product.quantity
                : 0;
            } else {
              total += product.price_default
                ? product.price_default * product.quantity
                : 0;
            }

            return total;
          }, 0);

          total += this.totalDineInFee() - this.totalVoucherDiscount;
          return total > 0 ? total : 0;
        } else {
          // EXCLUSIVE
          let total = this.itemSelect.reduce((total, product) => {
            if (this.isLogined || this.staffLogined) {
              total += product.member_price
                ? product.member_price * product.quantity
                : 0;
            } else {
              total += product.price_default
                ? product.price_default * product.quantity
                : 0;
            }

            return total;
          }, 0);

          total +=
            this.totalDineInFee() +
            this.convertedValueGstRate() -
            this.totalVoucherDiscount;
          return total > 0 ? total : 0;
        }
      } else {
        return 0;
      }
    },
    calculateTotalBeforeDiscount() {
      if (this.itemSelect && this.itemSelect.length > 0) {
        if (parseFloat(this.branch.gst_rate) < 0) {
          // INCLUSIVE
          let total = this.itemSelect.reduce((total, product) => {
            if (this.isLogined || this.staffLogined) {
              total += product.member_price
                ? product.member_price * product.quantity
                : 0;
            } else {
              total += product.price_default
                ? product.price_default * product.quantity
                : 0;
            }

            return total;
          }, 0);

          total += this.totalDineInFee();
          return total > 0 ? total : 0;
        } else {
          // EXCLUSIVE
          let total = this.itemSelect.reduce((total, product) => {
            if (this.isLogined || this.staffLogined) {
              total += product.member_price
                ? product.member_price * product.quantity
                : 0;
            } else {
              total += product.price_default
                ? product.price_default * product.quantity
                : 0;
            }

            return total;
          }, 0);

          total += this.totalDineInFee() + this.convertedValueGstRate();
          return total > 0 ? total : 0;
        }
      } else {
        return 0;
      }
    },
    totalGSTInclusive() {
      var gstConverted = Math.abs(this.branch.gst_rate) / 100;
      const rawGst =
        (this.calculateTotalAfterGST() / (1 + gstConverted)) * gstConverted;
      // Round half-up to 2 decimals (avoid `.toFixed(2)` rounding 0.495 down to 0.49).
      return Math.round((rawGst + Number.EPSILON) * 100) / 100;
    },
    // Returns whether it's safe to proceed to payment: true only when the
    // reload succeeded AND isCanPay came back 1. proccedToPayment() relies on
    // this — every other exit (busy, branch stopped, isCanPay==0, a business
    // error like an invalidated voucher, or a network failure) must resolve
    // false so a stale/rejected cart can never slip through to checkout.
    async reloadOrder() {
      if (this.payLoad) {
        return false;
      }

      this.payLoad = true;

      if (this.stopOrdering) {
        this.txtNotification = this.$t("kiosk.checkout.stopOrdering");
        $(".btn-notification-modal").click();
        this.payLoad = false;
        return false;
      } else {
        this.showLoader();
        let dataForm = {
          items: JSON.parse(localStorage.getItem(this.cartName) || "[]"),
          branch_code: this.$store.state.branchCode,
          member_id: this.memberId,
          promocode: this.rewardSelect,
          total_item: this.calculateTotal(),
        };

        return OrderService.reload(dataForm).then(
          async (response) => {
            if (response.data.result.isSuccess) {
              let dataResponse = response.data.data;
              this.MERCHANT_BRAND_NAME = dataResponse.merchant_brand_name ?? "";
              const previousItems = this.itemSelect || [];
              this.itemSelect = dataResponse.items;
              const priceChanges = this.applyReloadPrices(dataResponse.prices, previousItems);

              if (dataResponse.isCanPay == 0) {
                $(".btn-notification-out-stock-items-modal").click();
              } else {
                $(".btn-close-out-stock-items").click();
              }

              this.isCanPay = dataResponse.isCanPay;
              this.updateCartOrder();
              await this.calculateVoucherPrice();
              this.payLoad = false;
              this.hideLoader();
              // A repriced cart is shown to the guest before payment.
              return this.isCanPay == 1 && !priceChanges.length;
            } else {
              let warningMessage = response.data.result.message;
              var prefix = "prefixVoucherError-";
              if (warningMessage.startsWith(prefix)) {
                this.txtNotification = warningMessage.substring(prefix.length);
                $(".btn-notification-modal").click();

                this.rewardSelect = null;
                localStorage.removeItem(localStorageName("SELECTED_REWARD"));
              } else {
                this.snackbar = "danger";
                this.message = response.data.result.message;
                this.setTimeOutNotification();
              }
              $(".btn-close-out-stock-items").click();
              this.payLoad = false;
              this.hideLoader();
              return false;
            }
          },
          (error) => {
            $(".btn-close-out-stock-items").click();
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            this.hideLoader();
            this.payLoad = false;
            return false;
          }
        );
      }
    },
    getMainItemPriceAndModifiersPrice(item, total = 1) {
      // Use the already calculated price that includes modifiers
      var finalPrice = 0;
      if (this.isLogined || this.staffLogined) {
        finalPrice = item.member_price ? item.member_price : item.price_default;
      } else {
        finalPrice = item.price_default;
      }
      return this.formatPrice(finalPrice * (total ? item.quantity : 1));
    },
    // KSK119: the line at its usual base price (same modifiers / quantity) while a Special
    // Scheduled Price sells it lower; "" otherwise. The usual price comes from order/reload: a
    // line paid at the member price is struck at the usual member price.
    scheduleRegularLinePrice(item) {
      const saving = this.scheduleLineSaving(item);
      if (saving <= 0) return "";
      const paid = this.lineAtMemberPrice(item) ? item.member_price : item.price_default;
      return this.formatPrice(((parseFloat(paid) || 0) + saving) * item.quantity);
    },
    lineAtMemberPrice(item) {
      return (this.isLogined || this.staffLogined) && item.member_price;
    },
    // Per unit: what the Special Scheduled Price takes off the base price this viewer pays
    // (usual member price for a line at the member price, usual default otherwise); 0 if none.
    scheduleLineSaving(item) {
      if (item.is_free_item) return 0;
      const saving = this.lineAtMemberPrice(item)
        ? (parseFloat(item.original_member_price_no_modifier_option) || 0) -
          (parseFloat(item.member_price_no_modifier_option ?? item.member_price) || 0)
        : (parseFloat(item.original_price_no_modifier_option) || 0) -
          (parseFloat(item.price_default_no_modifier_option ?? item.price_default) || 0);
      return saving > 0 ? saving : 0;
    },
    getMainItem(item) {
      var priceMainAndModifer = 0;
      priceMainAndModifer =
        (this.isLogined || this.staffLogined) &&
        item.member_price_no_modifier_option
          ? item.price_default_no_modifier_option * item.quantity
          : 0;
      var totalPriceModifer = 0;

      if (item.choice) {
        if (item.choice_selected && item.choice_selected.items) {
          item.choice_selected.items.forEach((itemChoice) => {
            if (itemChoice.item_detail) {
              itemChoice.item_detail.modifier_group.forEach((group) => {
                group.items.forEach((itemModifier) => {
                  totalPriceModifer +=
                    itemModifier.price_default *
                    itemModifier.quantity *
                    itemChoice.qty;

                  if (
                    itemModifier.item_in_mog &&
                    itemModifier.item_in_mog.modifier_group
                  ) {
                    itemModifier.item_in_mog.modifier_group.forEach((subGroup) => {
                      subGroup.items.forEach((subItemModifier) => {
                        totalPriceModifer +=
                          subItemModifier.price_default *
                          subItemModifier.quantity *
                          itemModifier.quantity *
                          itemChoice.qty;
                      });
                    });
                  }
                });
              });
            }
          });
        }
      } else {
        if (item.modifier_group) {
          item.modifier_group.forEach((group) => {
            group.items.forEach((itemModifier) => {
              totalPriceModifer +=
                itemModifier.price_default * itemModifier.quantity;

              if (
                itemModifier.item_in_mog &&
                itemModifier.item_in_mog.modifier_group
              ) {
                itemModifier.item_in_mog.modifier_group.forEach((subGroup) => {
                  subGroup.items.forEach((subItemModifier) => {
                    totalPriceModifer +=
                      subItemModifier.price_default *
                      subItemModifier.quantity *
                      itemModifier.quantity;
                  });
                });
              }
            });
          });
        }
      }

      return priceMainAndModifer > 0
        ? this.formatPrice(
            priceMainAndModifer + totalPriceModifer * item.quantity
          )
        : "";
    },
    getModifierSubTotal(modifier) {
      // Branch-level toggle: hide item price next to name in kiosk cart.
      if (this.branch && !this.branch.show_item_price_in_cart_on_kiosk) return "";
      if (!modifier) return "";
      const price = parseFloat(modifier.price_default);
      if (isNaN(price) || price === 0) return "";
      const qty = parseInt(modifier.quantity) || 1;
      if (qty > 1) {
        return "(" + this.formatPrice(price) + ")";
      }
      return "(" + this.formatPrice(price) + ")";
    },
    getSubCategoryItemPrice(itemChoice) {
      // Show each sub category item's own price next to its name, same style as
      // modifiers. Respects the same branch toggle as the other kiosk prices.
      if (this.branch && !this.branch.show_item_price_in_cart_on_kiosk) return "";
      if (!itemChoice || !itemChoice.item_detail) return "";
      const unit =
        (this.isLogined || this.staffLogined) && itemChoice.item_detail.member_price
          ? itemChoice.item_detail.member_price
          : itemChoice.item_detail.price_default;
      const price = parseFloat(unit);
      if (isNaN(price) || price === 0) return "";
      return "(" + this.formatPrice(price) + ")";
    },
    showQuantityForMainItem(itemIndex) {
      this.clearIsEditQuantity();
      if (itemIndex !== -1) {
        if (!this.itemSelect[itemIndex].isEditQuantity) {
          this.itemSelect[itemIndex].isEditQuantity = true;
        } else {
          this.itemSelect[itemIndex].isEditQuantity = false;
        }
      }
    },
    async handleQuantityForMainItem(mainItem, type, itemIndex) {
      // 1 is - | 2 is +
      if (itemIndex !== -1 && type == 1) {
        if (this.itemSelect[itemIndex].quantity === 1) {
          // KSK052: going to 0 removes the line, so confirm first.
          this.closeAllModal();
          this.pendingRemoveIndex = itemIndex;
          this.txtConfirm = this.$t("kiosk.checkout.confirmRemoveFromCart", { name: this.tName(mainItem.item_name) });
          this.kskConfirmPreset = "removeItem";
          this.confirmType = 4;
          $(".btn-confirm-modal").click();
          return;
        } else {
          this.decrementItemQuantity(itemIndex);
        }
      } else if (itemIndex !== -1 && type == 2) {
        this.itemSelect[itemIndex].quantity =
          this.itemSelect[itemIndex].quantity + 1;
        this.updateCartOrder();
      }
      this.showLoader();
      if (this.rewardSelect && this.rewardSelect.length > 0) {
        if (this.rewardSelect[0].reward_type != FREE_ITEM) {
          // not free item
          await this.calculateVoucherPrice();
        }
      }
      this.hideLoader();
    },

    priceUpdateOf(item) {
      return this.repricedLines.find((line) => line.item === item) || null;
    },
    // order/reload returns `prices` (current base price per line) on a QR request:
    // kiosk/save-order takes the cart's prices as they are, so a cart kept past a schedule
    // change is repriced here and shown to the guest before payment.
    applyReloadPrices(prices, previousItems) {
      this.repricedLines = carryRepricedLines(this.repricedLines, previousItems, this.itemSelect);
      if (!Array.isArray(prices)) {
        return [];
      }
      const changed = applyCartPrices(this.itemSelect, prices, this.isLogined || this.staffLogined);
      if (!changed.length) {
        return changed;
      }
      this.repricedLines = [...this.repricedLines.filter((line) => !changed.some((c) => c.item === line.item)), ...changed];
      this.pricesUpdatedLines = changed.map((c) => ({
        name: this.tName(c.item.item_name),
        quantity: c.item.quantity,
        from: c.from,
        to: c.to,
      }));
      this.$refs.pricesUpdatedModal.open();
      return changed;
    },
    updateCartOrder() {
      localStorage.removeItem(this.cartName);
      const itemSelectedWithOutFreeItem = this.itemSelect.filter(
        (item) => !item.is_free_item
      );
      localStorage.setItem(
        this.cartName,
        JSON.stringify(itemSelectedWithOutFreeItem)
      );
    },

    closeModalNotificationHandler(removeItem = false) {
      if (removeItem && this.itemIndexSelected >= 0) {
        let itemIndex = this.itemIndexSelected;
        this.decrementItemQuantity(itemIndex);
        this.itemIndexSelected = -1;
      }
    },

    confirmPinCode() {
      $(".btn-hide-modal-confirm-pin-code").click();

      if (this.enableRetailMode == 1 && this.itemIndexSelected >= 0) {
        this.snackbar = "success";
        this.message = this.$t("kiosk.checkout.pinCorrect");
        this.setTimeOutNotification();
        this.pincodePassed = true;

        this.pincodePassedTimeout = setTimeout(() => {
          this.pincodePassed = false;
        }, 30000);

        let itemIndex = this.itemIndexSelected;

        if (this.itemSelect[itemIndex].quantity === 1) {
          // If quantity is going to be decremented to 0, show confirm dialog
          this.itemIndexSelected = itemIndex;
          this.txtNotification = this.$t("kiosk.order.confirmRemove", { name: this.tName(this.itemSelect[itemIndex].item_name) });
          $(".btn-notification-modal").click();
        } else {
          this.decrementItemQuantity(itemIndex);
          this.itemIndexSelected = -1;
        }
      }
    },

    confirmPasscode() {
      $(".btn-hide-modal-confirm-passcode").click();
      localStorage.setItem(localStorageName("PASSCODE_CONFIRMED"), 1);

      this.gotoPath("MyRewardPageKiosk");
    },

    decrementItemQuantity(itemIndex) {
      this.itemSelect[itemIndex].quantity =
        this.itemSelect[itemIndex].quantity - 1;
      if (this.itemSelect[itemIndex].quantity === 0) {
        this.itemSelect.splice(itemIndex, 1);
      }
      this.updateCartOrder();
    },

    clearIsEditQuantity() {
      this.itemSelect.forEach((item) => {
        delete item.isEditQuantity;
      });
      var dataItems = JSON.parse(localStorage.getItem(this.cartName) || "[]");
      localStorage.removeItem(this.cartName);

      if (dataItems && dataItems.length) {
        dataItems.forEach((itemObject) => {
          delete itemObject.isEditQuantity;
        });
        localStorage.setItem(this.cartName, JSON.stringify(dataItems));
      }
    },
    hideDiv(event) {
      const clickedElement = event.target;

      // Check if the clicked element doesn't have the class 'boxEditQuantityNormal'
      if (
        clickedElement &&
        !clickedElement.classList.contains("boxEditQuantity")
      ) {
        this.clearIsEditQuantity();
      }
    },
    gotoPath(name) {
      this.$router.push({
        name: name,
        params: {
          merchant_code: this.merchantCode,
          branch_code: this.branchCode,
        },
      });
    },
    confirmStartOver() {
      this.closeAllModal();

      // KSK112: retail keeps Start Over enabled on an empty cart (it is the
      // only way back to Landing), so confirm whatever the cart holds.
      this.txtConfirm = this.$t("kiosk.order.confirmStartOver");
      this.kskConfirmPreset = "startOver";
      this.confirmType = 1;
      $(".btn-confirm-modal").click();
    },
    startOver() {
      localStorage.removeItem(this.cartName);
      localStorage.removeItem(localStorageName("DINING_OPTION"));
      localStorage.removeItem(localStorageName("KIOSK_PROMO_CODE_APPLIED"));

      this.itemSelect = [];

      if (this.memberInfo) {
        this.logout();
      }

      this.gotoPath("LandingPageKiosk");
    },
    orderMore() {
      this.closeAllModal();
      this.gotoPath("OrderPageKiosk");
    },
    async proccedToPayment() {
      if (this.itemSelect && this.itemSelect.length > 0) {
        // Re-check stock/price/voucher against the backend right before
        // checkout (mirrors MyCart's reloadOrder(1)) — the cart can go stale
        // while the guest is browsing. reloadOrder() itself already surfaces
        // the right message (out-of-stock modal, voucher error, or a
        // snackbar), so just stop here on any failure — not only isCanPay==0,
        // but also a busy/stopped/errored reload where isCanPay never got
        // refreshed.
        const canProceed = await this.reloadOrder();
        if (!canProceed) {
          return;
        }

        // Free-item voucher: total payable is $0, so there is nothing to pay.
        // Create the order directly and skip the payment-method screen
        // (mirrors MyCart's total == 0 flow). A buzzer number is still
        // collected first when the branch requires it.
        if (parseFloat(this.totalPayable()) === 0) {
          this.handleFreeOrder();
          return;
        }

        if (this.staffLogined) {
          if (
            parseFloat(this.staffInfo.remaining_spending).toFixed(2) <
            parseFloat(this.calculateTotalBeforeDiscount().toFixed(2))
          ) {
            this.txtNotification = this.$t("kiosk.checkout.spendingLimit");
            $(".btn-notification-modal").click();
            return;
          }
        }

        this.$router.push({
          name: "PaymentSelectionPageKiosk",
          params: {
            merchant_code: this.merchantCode,
            branch_code: this.branchCode,
          },
        });
      }
    },
    async handleFreeOrder() {
      // Buzzer settings live on getBranchSetting (not BRANCH_INFO), so fetch
      // them on demand for the current dining option before placing the order.
      this.showLoader();
      await KioskService.getBranchSetting({ branch_code: this.branchCode }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.showBuzzerNumber =
              this.takeAwayOrDineIn == 2
                ? data.show_buzzer_number_dine_in
                : data.show_buzzer_number_takeaway;
            this.buzzerNumberText = data.buzzer_number_text;
          }
        }
      );
      this.hideLoader();

      // Require the buzzer number before creating the order when enabled.
      if (this.showBuzzerNumber && this.buzzerNumber === "") {
        this.keyReloadModalInputBuzzerNumber = Math.random().toString();
        $(".btn-show-modal-input-buzzer-number").click();
        return;
      }

      this.saveFreeOrder();
    },
    inputBuzzerNumber(number) {
      // Keep the modal open until a number is entered.
      if (!number || number.length === 0) {
        return;
      }
      $(".btn-hide-modal-input-buzzer-number").click();
      this.buzzerNumber = number;
      this.saveFreeOrder();
    },
    saveFreeOrder() {
      this.showLoader();
      let dataForm = {
        branch_code: this.branchCode,
        items: this.itemSelect,
        take_away_fee: this.totalDineInFee().toFixed(2),
        total_item: this.calculateTotal(),
        total_payment_amount: 0,
        gst_amount: this.convertedValueGstRate().toFixed(2),
        gst_rate: this.branch.gst_rate,
        buzzer_number: this.buzzerNumber,
        take_away_or_dine_in: this.takeAwayOrDineIn,
        member_id: this.memberInfo?.id || 0,
        is_staff: this.staffLogined ? 1 : 0,
        code: this.staffInfo?.code || "",
        total_voucher_discount: this.totalVoucherDiscount,
        voucher_code: this.rewardSelect,
        voucher_name:
          this.rewardSelect && this.rewardSelect.length > 0
            ? this.rewardSelect[0].reward_title
            : "",
        promo_code: this.promoCodeApplied?.promo_code || "",
        promo_name: this.promoCodeApplied?.promo_name || "",
        total_promo_discount: this.getPromoDiscountAmount() ?? 0,
        payment_mode: this.branch?.payment_mode || "",
        kiosk_payment_method: "",
        bcrs_deposit: 0,
        bcrs_deposit_qty: 0,
      };

      const numericValue = parseFloat(this.branch.gst_rate);
      if (numericValue < 0) {
        dataForm.gst_amount = this.totalGSTInclusive().toFixed(2);
      }

      KioskService.saveOrder(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const transaction = response.data.data;

            // Clear session data after a successful order (mirrors the
            // payment-success handlers in PaymentSelection.vue).
            localStorage.removeItem(this.cartName);
            localStorage.removeItem(localStorageName("DINING_OPTION"));
            localStorage.removeItem(localStorageName("KIOSK_PROMO_CODE_APPLIED"));
            if (this.isLogined || this.staffLogined) {
              localStorage.removeItem(localStorageName("STAFF_INFO"));
              localStorage.removeItem(localStorageName("PASSCODE_CONFIRMED"));
              localStorage.removeItem(localStorageName("SELECTED_REWARD"));
              memberService.logout(this.merchantCode);
            }

            this.$router.push({
              name: "PaymentSuccessPageKiosk",
              params: {
                merchant_code: this.merchantCode,
                branch_code: this.branchCode,
                transaction_id: transaction.transaction_id,
              },
            });
          } else if (isPromoCodeError(response.data.data)) {
            this.hideLoader();
            this.onPromoCodeUnavailable(promoReasonText(this.$t.bind(this), response.data.data, response.data.result.message));
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },
    resetIdleTimer() {
      // Reset thời gian khi có hoạt động
      this.lastActivity = Date.now();
      this.idleTime = 0;
      this.isIdle = false;
      clearInterval(this.idleInterval);
      this.idleInterval = null;
      this.startIdleTimer();
    },
    startIdleTimer() {
      // KSK063: no "still there?" countdown inside Minty's preview.
      if (isKioskPreview()) return;
      this.idleInterval = setInterval(() => {
        const currentTime = Date.now();
        const timeDiff = (currentTime - this.lastActivity) / 1000;
        this.idleTime = Math.floor(timeDiff);

        if (timeDiff >= 60) {
          this.closeAllModal();

          this.keyReloadModalConfirmStillThere = Math.random();
          $(".btn-show-modal-confirm-still-there").click();

          this.isIdle = true;
          this.idleTime = 0;
          clearInterval(this.idleInterval);
          this.idleInterval = null;
        }
      }, 1000);
    },
    continueMyOrder() {
      this.closeAllModal();
      this.resetIdleTimer();
    },
    resetNow() {
      this.closeAllModal();
      localStorage.removeItem(this.cartName);
      this.itemSelect = [];
      localStorage.removeItem(localStorageName("DINING_OPTION"));
      localStorage.removeItem(localStorageName("KIOSK_PROMO_CODE_APPLIED"));
      this.logout();
      this.gotoPath("LandingPageKiosk");
    },
    closeAllModal() {
      $(".btn-close-modal-confirm-passcode").click();
      $(".btn-close-modal-confirm-pin-code").click();
      $(".btn-close-modal-confirm").click();
      $(".btn-close-notification-modal").click();
      $(".btn-hide-modal-signin").click();
      $(".btn-hide-modal-notification-out-stock-items").click();
      $(".btn-hide-modal-confirm-still-there").click();
      $(".btn-hide-modal-promo-code").click();
    },
    // KSK011: moved unchanged from Header.vue (checkout was its only user).
    async getTotalReward() {
      let dataForm = {
        type: "",
        merchant_id: localStorage.getItem(localStorageName("MERCHANT_ID"), 0),
        branch_code: this.branchCode,
        get_total_reward: 1
      };

      await PromocodeService.getMyRewardOrderingOnline(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.totalReward = response.data.data.total_reward;
          } else {
            console.log(response.data.result.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    gotoMyRewardPageKiosk() {
      if (this.totalReward == 0) {
        return;
      }

      const passcodeConfirmed = localStorage.getItem(localStorageName("PASSCODE_CONFIRMED")) ?? 0;

      if (this.requirePasscodeEntryToRedeemVouchers == 1 && !passcodeConfirmed) {
        EventBus.emit("ShowModalConfirmPasscode");
      } else {
        this.gotoPath("MyRewardPageKiosk");
      }
    },
    // KSK052: the header chip opens the "Where will you be eating" popup.
    openDiningOption() {
      if (!this.canToggleDining) return;
      $(".btn-show-modal-select-dining-option").click();
    },
    onPickDiningOption(value) {
      // Wait until the popup is fully closed: the switch may open ModalConfirm next.
      // Bootstrap 5 fires native events, so jQuery .one() would never see it.
      const modal = document.getElementById("modalSelectDiningOption");
      const apply = () => {
        if (value != this.takeAwayOrDineIn) this.changeDiningOption(value);
      };
      if (modal) modal.addEventListener("hidden.bs.modal", apply, { once: true });
      $(".btn-hide-modal-select-dining-option").click();
      if (!modal) apply();
    },
    onMembershipSignIn() {
      $(".btn-show-modal-signin").click();
    },
    confirmLogout() {
      this.txtConfirm = this.$t("kiosk.common.confirmLogout");
      this.kskConfirmPreset = "logout";
      this.confirmType = 2;
      $(".btn-confirm-modal").click();
    },
    logout() {
      memberService.logout(this.merchantCode);
      localStorage.removeItem(localStorageName("STAFF_INFO"));
      localStorage.removeItem(localStorageName("SELECTED_REWARD"));
      localStorage.removeItem(localStorageName("PASSCODE_CONFIRMED"));
      this.memberInfo = null;
      this.isLogined = false;
      this.staffInfo = null;
      this.staffLogined = false;
      this.itemVoucherApplied = [];
      this.rewardSelect = null;
      this.promoCodeApplied = null;
      this.isPromoCodeApplied = false;

      this.updateCartOrder();

      this.itemSelect = JSON.parse(localStorage.getItem(this.cartName) || "[]");

      if (this.enableRetailMode == 1) {
        localStorage.removeItem(localStorageName("DINING_OPTION"));
        this.gotoPath("LandingPageKiosk");
      }

      EventBus.emit("LogoutSuccess");

      setTimeout(() => {
        const headerHeight = $("header").height();
        const footerHeight = $(".footer").height() + 68;
        $(".content").css(
          "height",
          `calc(var(--ksk-vh, 1vh) * 100 - ${headerHeight + footerHeight}px)`
        );

        $(".content").css("margin-top", "92px");
      }, 100);

      this.snackbar = "success";
      this.message = this.$t("kiosk.common.logoutSuccess");
      this.setTimeOutNotification();
    },
    async getStaffRemainingSpending() {
      var dataForm = {
        staff_id: this.staffInfo?.id || 0,
      };

      await KioskService.getStaffRemainingSpending(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.staffInfo.remaining_spending =
              response.data.data.staff_remaining_spending;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.setTimeOutNotification();
        }
      );
    },
    processYes() {
      this.closeAllModal();

      if (this.confirmType == 1) {
        // start over
        this.startOver();
      } else if (this.confirmType == 2) {
        // logout
        this.logout();
      } else if (this.confirmType == 3) {
        // switch dining option, dropping items with modifiers for the other one
        this.confirmDiningOptionChange();
      } else if (this.confirmType == 4) {
        // remove the item whose quantity went to 0
        this.confirmRemoveItem();
      }
    },
    async confirmRemoveItem() {
      const itemIndex = this.pendingRemoveIndex;
      this.pendingRemoveIndex = -1;
      if (itemIndex < 0 || !this.itemSelect[itemIndex]) return;
      this.decrementItemQuantity(itemIndex);
      this.showLoader();
      if (this.rewardSelect && this.rewardSelect.length > 0) {
        if (this.rewardSelect[0].reward_type != FREE_ITEM) {
          await this.calculateVoucherPrice();
        }
      }
      this.hideLoader();
    },
    voucherError(errMessage) {
      this.txtNotification = errMessage;
      $(".btn-notification-modal").click();

      this.rewardSelect = null;
      this.itemVoucherApplied = [];
      this.totalVoucherDiscount = 0;
      this.voucher_deducted_format = "";
      localStorage.removeItem(localStorageName("SELECTED_REWARD"));
    },
    showPromoCodeModal() {
      // Check if user is logged in and already has voucher applied
      if (this.isLogined && this.rewardSelect && this.rewardSelect.length > 0) {
        this.snackbar = "danger";
        this.message = this.$t("kiosk.checkout.voucherOrPromo");
        this.setTimeOutNotification();
        return;
      }

      // Show the promo code modal
      $(".btn-show-modal-promo-code").click();
    },
    async handleApplyPromoCode(promoCode, isRecheck = false) {
      this.showLoader();

        // Call API to validate and apply promo code
        let dataForm = {
          branch_code: this.branch.branch_code,
          member_id: this.memberId,
          promo_code: promoCode,
          order_total: this.calculateTotal(),
          // M977: a report-group promo is checked against the items in the cart,
          // priced the way calculateTotal() prices them
          items: this.itemSelect,
          is_staff: this.staffLogined ? 1 : 0,
        };

        await KioskService.checkPromoCode(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              const promoData = response.data.data;
              this.promoCodeApplied = promoData;
              this.isPromoCodeApplied = true;

              // Save promo code data to localStorage
              localStorage.setItem(
                localStorageName("KIOSK_PROMO_CODE_APPLIED"),
                JSON.stringify(this.promoCodeApplied)
              );

              setTimeout(() => {
                const headerHeight = $("header").height();
                const footerHeight = $(".footer").height() + (this.memberInfo ? 10 : 50);
                $(".content").css(
                  "height",
                  `calc(var(--ksk-vh, 1vh) * 100 - ${headerHeight + footerHeight}px)`
                );

                $(".content").css("margin-top", "92px");
              }, 10);

              this.$refs.modalPromoCode.applySucceeded();
            } else if (isRecheck && isPromoCodeError(response.data.data)) {
              // The code saved with the cart no longer works (expired, out of its schedule ...).
              this.onPromoCodeUnavailable(promoReasonText(this.$t.bind(this), response.data.data, response.data.result.message), promoCode);
            } else if (isRecheck) {
              // Not about the code (member / branch lookup, server error): keep it, save-order
              // checks it again.
              return;
            } else {
              // KSK027: the reason shows inside the still-open popup.
              this.$refs.modalPromoCode.applyFailed(promoReasonText(this.$t.bind(this), response.data.data, response.data.result.message));
            }
          },
          () => {
            this.$refs.modalPromoCode.applyFailed();
          }
        );

      this.hideLoader();
    },
    // The applied code can no longer be used (expired, out of its schedule, used up ...): drop it
    // and say why in a modal, so the guest sees the new total before paying.
    onPromoCodeUnavailable(reason, code = this.promoCodeApplied?.promo_code) {
      this.removePromoCode();
      this.txtNotification = promoRemovedMessage({
        title: this.$t("kiosk.checkout.promoCodeRemoved", { code: code || "" }),
        reason,
        note: this.$t("kiosk.checkout.promoCodeRemovedNote"),
      });
      $(".btn-notification-modal").click();
    },
    removePromoCode() {
      this.promoCodeApplied = null;
      this.isPromoCodeApplied = false;
      localStorage.removeItem(localStorageName("KIOSK_PROMO_CODE_APPLIED"));

      setTimeout(() => {
        const headerHeight = $("header").height();
        const footerHeight = $(".footer").height() + (this.memberInfo ? 10 : 50);
        $(".content").css(
          "height",
          `calc(var(--ksk-vh, 1vh) * 100 - ${headerHeight + footerHeight}px)`
        );

        $(".content").css("margin-top", "92px");
      }, 10);
    },

    changeDiningOption(value) {
      const invalidCount = getCartItemIndexesInvalidForDiningOption(this.itemSelect, value).length;
      if (invalidCount) {
        this.pendingDiningOption = value;
        this.txtConfirm = this.$t("kiosk.checkout.switchDiningInvalid", { count: invalidCount, option: this.$t(value == DINE_IN ? "kiosk.common.dineIn" : "kiosk.common.takeAway") });
        this.kskConfirmPreset = "switchDining";
        this.confirmType = 3;
        $(".btn-confirm-modal").click();
        return;
      }

      this.applyDiningOption(value);
    },

    applyDiningOption(value) {
      this.takeAwayOrDineIn = value;
      localStorage.setItem(localStorageName("DINING_OPTION"), this.takeAwayOrDineIn);
      EventBus.emit("DiningOptionChanged");
      this.$nextTick(() => {
        this.recalculateLayout();
      });
    },

    confirmDiningOptionChange() {
      const value = this.pendingDiningOption;
      this.pendingDiningOption = null;

      const invalidIndexes = getCartItemIndexesInvalidForDiningOption(this.itemSelect, value);
      this.itemSelect = this.itemSelect.filter((item, index) => !invalidIndexes.includes(index));
      this.updateCartOrder();

      this.applyDiningOption(value);
    },

    recalculateLayout() {
      const headerHeight = $("header").height();
      const footerHeight = $(".footer").height() + 48;
      $(".content").css(
        "height",
        `calc(var(--ksk-vh, 1vh) * 100 - ${headerHeight + footerHeight}px)`
      );
    },

    removeVoucher() {
      this.rewardSelect = null;
      this.totalVoucherDiscount = 0;
      this.voucher_deducted_format = "";
      this.itemVoucherApplied = [];
      localStorage.removeItem(localStorageName("SELECTED_REWARD"));

      // Drop any free item that was added by a FREE_ITEM voucher from the cart display.
      this.updateCartOrder();
      this.itemSelect = JSON.parse(localStorage.getItem(this.cartName) || "[]");
    },

    getPromoDiscountAmount() {
      if (!this.isPromoCodeApplied || !this.promoCodeApplied) {
        return 0;
      }

      // Calculate base total (subtotal)
      let baseTotal = this.calculateTotal();

      return this.promoDiscountFor(baseTotal);
    },

    async editCartItem(item, index) {
      this.editItemIndex = index;
      this.showLoader();

      try {
        // Get category_id from item or from store
        let categoryId = item.category_id || 0;

        // If no category_id in item, need to fetch from API
        if (!categoryId) {
          // May need to call API to get category_id based on item_id
          // Or save category_id when add to cart
        }

        let dataForm = {
          menuset_id: this.branch.menuset_id ?? 0,
          category_id: categoryId,
          item_id: item.id,
          branch_code: this.branch.branch_code ?? "",
          take_away_or_dine_in: getDiningOption(),
          is_kiosk: 1,
        };

        await OrderService.getItemDetail(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              let itemDetail = response.data.data;

              // Restore modifiers from cart item into itemDetail
              this.restoreModifiersFromCart(itemDetail, item);

              // Set quantity from cart item
              itemDetail.quantity = item.quantity;

              // Set prices
              itemDetail.price_default = parseFloat(item.price_default || itemDetail.price_default);
              itemDetail.member_price = parseFloat(item.member_price || itemDetail.member_price);

              this.categoryIdSelect = categoryId;
              this.itemIdSelect = item.id;
              this.itemDetail = itemDetail;
              this.reloadModal = Math.random().toString();

              // Open modal
              setTimeout(() => {
                $('.btn-show-item-detail-modal').click();
              }, 100);
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
          }
        );
      } catch (error) {
        this.hideLoader();
        console.error('Error editing item:', error);
      }
    },

    resetModifiersState(itemDetail) {
      // Reset modifiers for regular item
      if (itemDetail.modifier_group) {
        itemDetail.modifier_group.forEach((group) => {
          group.total_selected = 0;
          group.items.forEach((item) => {
            item.selected = false;
            item.quantity = 1;
            // Reset nested modifiers
            if (item.item_in_mog && item.item_in_mog.modifier_group) {
              this.resetModifiersState({ modifier_group: item.item_in_mog.modifier_group });
            }
          });
        });
      }

      // Reset modifiers for choice items
      if (itemDetail.choices) {
        itemDetail.choices.forEach((choice) => {
          if (choice.items) {
            choice.items.forEach((choiceItem) => {
              if (choiceItem.item_detail && choiceItem.item_detail.modifier_group) {
                this.resetModifiersState(choiceItem.item_detail);
              }
            });
          }
        });
      }
    },

    restoreModifiersFromCart(itemDetail, cartItem) {
      // IMPORTANT STEP: Reset all modifiers to initial state before restoring
      this.resetModifiersState(itemDetail);

      // If item has choice (combo)
      if (cartItem.choice_selected && cartItem.choice_selected.items) {
        itemDetail.choice_selected = JSON.parse(JSON.stringify(cartItem.choice_selected));

        // Find the matching choice tab by id, then restore modifiers for items within it
        if (itemDetail.choices) {
          const matchingChoiceIndex = itemDetail.choices.findIndex(
            (c) => c.id === cartItem.choice_selected.id
          );
          const matchingChoice = matchingChoiceIndex >= 0
            ? itemDetail.choices[matchingChoiceIndex]
            : null;

          if (matchingChoice && matchingChoice.items) {
            cartItem.choice_selected.items.forEach((savedChoiceItem) => {
              if (savedChoiceItem.item_detail && savedChoiceItem.item_detail.modifier_group) {
                const matchingItem = matchingChoice.items.find(ci => ci.id === savedChoiceItem.id);
                if (matchingItem && matchingItem.item_detail) {
                  this.restoreModifierGroup(
                    matchingItem.item_detail.modifier_group,
                    savedChoiceItem.item_detail.modifier_group
                  );
                }
              }
            });
          }
        }
      } else if (cartItem.modifier_group) {
        // Restore modifiers for regular item
        this.restoreModifierGroup(itemDetail.modifier_group, cartItem.modifier_group);
      }
    },

    restoreModifierGroup(detailModifiers, cartModifiers) {
      if (!detailModifiers || !cartModifiers) return;

      // Map by id but ensure each detailGroup is used only once
      const usedDetailIndexes = new Set();

      cartModifiers.forEach((cartGroup) => {
        const detailIndex = detailModifiers.findIndex(
          (dg, idx) => dg.id === cartGroup.id && !usedDetailIndexes.has(idx)
        );
        if (detailIndex === -1) return;

        const detailGroup = detailModifiers[detailIndex];
        usedDetailIndexes.add(detailIndex);

        // Reset group to clean state
        detailGroup.total_selected = 0;
        detailGroup.items_selected = [];
        detailGroup.items.forEach((it) => {
          it.selected = false;
          it.quantity = 1;
          if (it.item_in_mog && it.item_in_mog.modifier_group) {
            this.resetModifiersState({ modifier_group: it.item_in_mog.modifier_group });
          }
        });

        // Restore from cart: item, quantity, selected, items_selected, total_selected
        cartGroup.items.forEach((cartItem) => {
          const detailIndex = detailGroup.items.findIndex((di) => di.id === cartItem.id);
          if (detailIndex === -1) return;

          const detailItem = detailGroup.items[detailIndex];

          detailItem.selected = !!cartItem.selected;
          detailItem.quantity = cartItem.quantity || 1;

          if (detailItem.selected) {
            // Add index to items_selected like runtime logic
            if (!detailGroup.items_selected) detailGroup.items_selected = [];
            if (!detailGroup.items_selected.includes(detailIndex)) {
              detailGroup.items_selected.push(detailIndex);
            }
          }

          // Nested modifiers
          if (cartItem.item_in_mog && cartItem.item_in_mog.modifier_group) {
            const detailHasNested =
              detailItem.item_in_mog &&
              Array.isArray(detailItem.item_in_mog.modifier_group) &&
              detailItem.item_in_mog.modifier_group.length > 0;

            if (!detailHasNested) {
              detailItem.item_in_mog = JSON.parse(
                JSON.stringify(cartItem.item_in_mog)
              );
            } else {
              this.restoreModifierGroup(
                detailItem.item_in_mog.modifier_group,
                cartItem.item_in_mog.modifier_group
              );
            }
          }
        });

        // Finally, get total_selected from cart (if exists) or recalculate from items_selected
        if (typeof cartGroup.total_selected === "number") {
          detailGroup.total_selected = cartGroup.total_selected;
        } else {
          detailGroup.total_selected = detailGroup.items_selected
            ? detailGroup.items_selected.length
            : 0;
        }
      });
    },

    async handleItemUpdated(updatedItem) {
      // When item is updated from modal, replace item in cart
      if (this.editItemIndex >= 0 && this.editItemIndex < this.itemSelect.length) {
        // Remove old item and add new item
        this.itemSelect.splice(this.editItemIndex, 1, updatedItem);
        this.updateCartOrder();

        // Recalculate voucher if exists (skip FREE_ITEM — calculateVoucherPrice()
        // unconditionally pushes the free item, which would duplicate it here)
        if (this.rewardSelect && this.rewardSelect.length > 0) {
          if (this.rewardSelect[0].reward_type != FREE_ITEM) {
            await this.calculateVoucherPrice();
          }
        }
      }

      this.editItemIndex = -1;
    },

    clearDataItem() {
      this.itemIdSelect = 0;
      this.itemDetail = {};
      this.editItemIndex = -1;

      // An add-on with options was added by ModalItemDetail straight into the
      // stored cart: pick it up, keeping the voucher's free-item lines.
      if (this.addingUpsellItem) {
        this.addingUpsellItem = false;
        const freeItems = this.itemSelect.filter((item) => item.is_free_item);
        this.itemSelect = [
          ...JSON.parse(localStorage.getItem(this.cartName) || "[]"),
          ...freeItems,
        ];
        this.recalculateVoucherAfterCartChange();
      }
    },

    // ---- Popular Add-Ons (same endpoints the old upsell popup used) ----
    loadUpsells() {
      if (!this.branch || !this.branch.menuset_id) return;
      const dataForm = { set_id: this.branch.menuset_id };
      OrderService.checkShowUpsellItems(dataForm).then(
        (response) => {
          if (!response.data.result.isSuccess || !response.data.data.is_enabled_upsell) {
            return;
          }
          OrderService.getUpsellItems(dataForm).then(
            (itemsResponse) => {
              const data = itemsResponse.data.data;
              this.upsellItems =
                itemsResponse.data.result.isSuccess && data && Array.isArray(data.upsell_items)
                  ? data.upsell_items.filter((row) => row && row.item)
                  : [];
            },
            () => {
              this.upsellItems = [];
            }
          );
        },
        () => {
          this.upsellItems = [];
        }
      );
    },

    upsellPrice(row) {
      const price = parseFloat(row.item.price_default);
      return isNaN(price) ? 0 : price;
    },

    async addUpsellItem(row) {
      const src = row.item;
      if (Number(src.isHaveModifierOptionGroups) > 0) {
        this.openUpsellItemDetail(src);
        return;
      }

      // Simple item: +1 on the same id & price line, else a new line
      // (same cart shape the old upsell popup wrote).
      const price = this.upsellPrice(row);
      const existing = this.itemSelect.find(
        (item) =>
          !item.is_free_item &&
          item.id === src.id &&
          parseFloat(item.price_default) === price
      );
      if (existing) {
        existing.quantity += 1;
      } else {
        const memberPrice = parseFloat(src.member_price || src.price_default);
        this.itemSelect.push({
          id: src.id,
          choice: src.choice,
          choices: src.choices,
          item_name: src.item_name,
          item_no: src.item_no,
          description: src.description,
          price_default: price,
          price_default_no_modifier_option: price,
          member_price: memberPrice,
          member_price_no_modifier_option: memberPrice,
          quantity: 1,
          category_id: src.category_id || 0,
          menuset_id: src.menuset_id || 0,
          branch_code: this.branchCode,
          image: src.image || null,
          eligible_bcrs: src.eligible_bcrs,
          source: "upsell",
        });
      }
      this.updateCartOrder();
      this.snackbar = "success";
      this.message = this.$t("kiosk.common.addedToCartSuccess");
      this.setTimeOutNotification();
      await this.recalculateVoucherAfterCartChange();
    },

    openUpsellItemDetail(src) {
      const categoryId = src.category_id || 0;
      const dataForm = {
        menuset_id: this.branch.menuset_id ?? 0,
        category_id: categoryId,
        item_id: src.id,
        branch_code: this.branch.branch_code ?? "",
        take_away_or_dine_in: getDiningOption(),
        is_kiosk: 1,
      };
      this.showLoader();
      OrderService.getItemDetail(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const itemDetail = response.data.data;
            // Keep the upsell price as the base (options are added on top).
            const price = parseFloat(src.price_default);
            if (!itemDetail.choice && price > 0) {
              const memberPrice = parseFloat(src.member_price || price);
              itemDetail.price_default_no_modifier_option = price;
              itemDetail.member_price_no_modifier_option = memberPrice;
              itemDetail.price_default = price;
              itemDetail.member_price = memberPrice;
            }
            itemDetail.quantity = 1;

            this.editItemIndex = -1;
            this.addingUpsellItem = true;
            this.categoryIdSelect = categoryId;
            this.itemIdSelect = src.id;
            this.itemDetail = itemDetail;
            this.reloadModal = Math.random().toString();
            setTimeout(() => {
              $(".btn-show-item-detail-modal").click();
            }, 100);
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
        }
      );
    },

    // Same voucher refresh handleQuantityForMainItem runs after a cart change.
    async recalculateVoucherAfterCartChange() {
      if (this.rewardSelect && this.rewardSelect.length > 0) {
        if (this.rewardSelect[0].reward_type != FREE_ITEM) {
          this.showLoader();
          await this.calculateVoucherPrice();
          this.hideLoader();
        }
      }
    },

  },
};
</script>
<style scoped>
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-body {
  padding: 0 !important;
}

.modifier-name {
  width: 65%;
  color: black;
}

.total-section,
.fee-section {
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
}

.total-label,
.fee-label {
  color: black;
  width: 75%;
}

.total-amount,
.fee-amount {
  color: black;
  width: 35%;
}

.voucher-container {
  width: 100%;
  height: 100%;
  background: #eb472f;
  border-radius: 3px;
  position: relative;
}

.voucher-text {
  color: white;
  font-size: 12px;
  font-weight: 600;
}

.grid-container {
  display: grid;
}

.disabled-pay-button {
  /* opacity: 0.5; */
  padding: 10px 10px;
  background: white;
  color: gray;
  font-size: 18px;
  font-weight: 500;
  border: 0.5px solid gray;
  text-align: center;
  border-radius: 10px;
}

.color-green {
  color: green !important;
}

.md-30 {
  font-size: 30px;
}

.search-input::placeholder {
  text-align: left !important;
  direction: ltr !important;
}

/* ---------- KSK010: page body ---------- */
.ksk-co__scroll {
  position: fixed;
  top: var(--ksk-header-height);
  left: 0;
  right: 0;
  /* KSK125: runs 28px under the footer so its rounded corners sit on the
     page colour, not the white app shell; padding keeps content clear. */
  bottom: calc(var(--ksk-co-bar-height, 112px) + var(--ksk-powered-height) - 28px);
  overflow-y: auto;
  padding: var(--ksk-space-3) var(--ksk-space-3) calc(var(--ksk-space-4) + 28px);
  background: var(--ksk-background);
  font-family: var(--ksk-font);
  color: var(--ksk-text);
}
.ksk-co__scroll::-webkit-scrollbar {
  display: none;
}
.ksk-co__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ksk-space-2);
  margin-bottom: var(--ksk-space-2);
}
.ksk-co__title-main {
  display: flex;
  align-items: baseline;
  gap: 12px;
  min-width: 0;
}
.ksk-co__title-count {
  font-size: 22px;
  line-height: 30px;
  font-weight: 500;
  color: var(--ksk-text-secondary);
  white-space: nowrap;
}
.ksk-co__dining-swap {
  margin-left: 4px;
  font-size: 24px;
  opacity: 0.8;
}
.ksk-co__dining-row {
  margin-top: var(--ksk-space-3);
}
.ksk-co__title {
  margin: 0;
  font-family: var(--ksk-font);
  font-size: 36px;
  line-height: 44px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--ksk-text);
}
.ksk-co__wait {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--ksk-caption-size);
  color: var(--ksk-warning);
  white-space: nowrap;
}
.ksk-co__wait strong {
  font-weight: 700;
}
.ksk-co__wait .material-icons-round {
  font-size: 24px;
}

.ksk-co__member-name {
  font-size: var(--ksk-item-size);
  line-height: var(--ksk-item-lh);
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ksk-co__member-id {
  font-size: var(--ksk-caption-size);
  line-height: var(--ksk-caption-lh);
  color: var(--ksk-text-secondary);
}

/* ---------- KSK010: line items ---------- */
/* Order list: one card, items as rows split by hairlines (reads like a
   receipt), "Order More" as its last row. */
.ksk-co__list {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface);
  box-shadow: var(--ksk-shadow-card);
}
.ksk-line {
  display: flex;
  align-items: center;
  gap: var(--ksk-space-2);
  padding: 20px 0;
  border-bottom: 1px solid var(--ksk-border);
  font-family: var(--ksk-font);
}
.ksk-co__list > .ksk-line:last-of-type {
  border-bottom: 0;
}
.ksk-co__list--empty {
  display: none;
}
.ksk-line__img {
  width: 120px;
  height: 120px;
  flex: none;
  align-self: flex-start;
  border-radius: 16px;
  object-fit: cover;
  background: var(--ksk-surface-muted);
}
.ksk-line__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ksk-line__name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: var(--ksk-item-size);
  line-height: var(--ksk-item-lh);
  font-weight: 700;
  color: var(--ksk-text);
  word-break: break-word;
}
.ksk-line__tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ksk-space-1);
}
.ksk-line__pill {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 10px;
  border-radius: var(--ksk-radius-pill);
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
}
.ksk-line__pill--free {
  background: var(--ksk-primary);
  color: var(--ksk-on-primary);
}
.ksk-line__pill--repriced {
  background: #ffe8b3;
  color: #7a4d00;
}
.ksk-line__pill--bcrs {
  background: var(--ksk-primary-container);
  color: var(--ksk-primary);
}
.ksk-line__base {
  font-size: var(--ksk-caption-size);
  font-weight: 600;
  color: var(--ksk-text-secondary);
  font-variant-numeric: tabular-nums;
}
.ksk-line__na {
  font-size: var(--ksk-caption-size);
  font-weight: 700;
  color: var(--ksk-error);
}
.ksk-line__choice {
  margin-top: 2px;
}
.ksk-line__choice-name {
  font-size: var(--ksk-caption-size);
  line-height: var(--ksk-caption-lh);
  font-weight: 600;
  color: var(--ksk-text);
  /* KSK083: a long set-choice name wraps inside the item column. */
  overflow-wrap: anywhere;
}
.ksk-line__choice-name .ksk-line__pill,
.ksk-line__choice-name .ksk-line__base {
  margin-left: 6px;
}
.ksk-line__choice :deep(.ksk-mods) {
  padding-left: var(--ksk-space-2);
}
.ksk-line__price {
  flex: none;
  min-width: 120px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.ksk-line__total {
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  color: var(--ksk-text);
  white-space: nowrap;
}
.ksk-line__was {
  font-size: 18px;
  line-height: 24px;
  color: var(--ksk-text-secondary);
  text-decoration: line-through;
  white-space: nowrap;
}
.ksk-line__price--applied .ksk-line__total {
  color: var(--ksk-primary);
}
.ksk-line__actions {
  flex: none;
  display: flex;
  align-items: center;
  gap: var(--ksk-space-2);
}
/* Compact stepper in cart lines (KskStepper is 80px elsewhere). KSK078: +
   keeps KskStepper's solid theme-colour circle — no light tint override. */
.ksk-line__actions :deep(.ksk-stepper) {
  height: 52px;
  min-width: 148px;
  gap: 4px;
  padding: 0 4px;
}
.ksk-line__actions :deep(.ksk-stepper__btn) {
  width: 44px;
  height: 44px;
}
.ksk-line__actions :deep(.ksk-stepper__btn .material-icons-round) {
  font-size: 24px;
}
.ksk-line__actions :deep(.ksk-stepper__value) {
  font-size: 22px;
}
.ksk-line__edit {
  align-self: flex-start;
  margin-top: 6px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 44px;
  padding: 0 var(--ksk-space-2);
  border: 1px solid var(--ksk-border);
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-surface);
  color: var(--ksk-primary);
  font-family: var(--ksk-font);
  font-size: var(--ksk-caption-size);
  font-weight: 700;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.ksk-line__edit .material-icons-round {
  font-size: 24px;
}
.ksk-line__edit:active:not(:disabled) {
  transform: scale(0.97);
}
.ksk-line__edit:disabled {
  opacity: 0.4;
  cursor: default;
}
/* Unavailable: fade the item, keep the red label readable. */
.ksk-line--na .ksk-line__img,
.ksk-line--na .ksk-line__name,
.ksk-line--na .ksk-line__price {
  opacity: 0.4;
}

/* ---------- KSK011: offers, dining, bill, sticky CTA ---------- */
.ksk-co__card {
  margin-top: var(--ksk-space-3);
  padding: 20px;
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface);
  box-shadow: var(--ksk-shadow-card);
}
.ksk-co__card-title {
  display: flex;
  align-items: center;
  gap: var(--ksk-space-1);
  margin: 0 0 var(--ksk-space-2);
  font-family: var(--ksk-font);
  font-size: var(--ksk-item-size);
  line-height: var(--ksk-item-lh);
  font-weight: 700;
  color: var(--ksk-text);
}
.ksk-co__card-title .material-icons-round {
  font-size: 28px;
  color: var(--ksk-primary);
}
/* Section heading outside a card (Popular Add-Ons). */
.ksk-co__section-title {
  margin: var(--ksk-space-4) 0 12px;
  font-family: var(--ksk-font);
  font-size: var(--ksk-item-size);
  line-height: var(--ksk-item-lh);
  font-weight: 700;
  color: var(--ksk-text);
}
/* Summary: top part of the fixed footer sheet (above Start Over / Payment),
   compact: offers as one row of buttons, small charge rows, the total. */
.ksk-co__summary {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: var(--ksk-space-3);
  /* Offers vertically centred against the charges + total column. */
  align-items: center;
  padding: 20px var(--ksk-space-3) var(--ksk-space-2);
  font-family: var(--ksk-font);
  color: var(--ksk-text);
}
/* KSK111: retail has no offers column — the bill takes the full width. */
.ksk-co__summary--retail {
  grid-template-columns: minmax(0, 1fr);
}
.ksk-co__summary-left {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}
/* KSK065: guests have no applied rows here — offers sit at the top. */
.ksk-co__summary-left--top {
  align-self: start;
}
/* Offers stacked in the left column, each only as wide as its label. */
.ksk-co__summary-offers {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}
.ksk-co__summary .ksk-co__offer {
  width: auto;
  max-width: 100%;
  min-width: 0;
  min-height: 52px;
  margin: 0;
  padding: 0 12px 0 var(--ksk-space-2);
  gap: 10px;
  border: 1px solid var(--ksk-border);
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-surface);
  font-size: 20px;
}
.ksk-co__summary .ksk-co__offer-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ksk-co__summary .ksk-co__offer > .material-icons-round:first-child {
  font-size: 26px;
}
.ksk-co__summary .ksk-co__chevron {
  font-size: 26px;
}
.ksk-co__summary .ksk-co__count {
  min-width: 32px;
  height: 32px;
  padding: 0 10px;
  font-size: 16px;
}
.ksk-co__summary .ksk-co__applied {
  min-height: 52px;
  margin: 0;
  padding: 0 8px 0 12px;
  gap: 10px;
  font-size: 18px;
}
.ksk-co__summary .ksk-co__applied-icon {
  width: 32px;
  height: 32px;
  font-size: 20px;
}
.ksk-co__summary .ksk-co__remove {
  height: 40px;
  padding: 0 14px;
}
/* Right column: charges, then the total.
   KSK058: no dividers in the summary. */
/* KSK104: figures 2px in from the Payment button's edge — the pill's curve
   makes an exact edge look like it overhangs. */
.ksk-co__summary .ksk-co__bill {
  min-width: 0;
  padding-right: 2px;
}
/* KSK103: charge labels in the main text colour, not grey. */
.ksk-co__summary .ksk-co__bill-row {
  padding: 3px 0;
  font-size: 20px;
  line-height: 28px;
  color: var(--ksk-text);
}
.ksk-co__summary .ksk-co__bill-row--discount {
  margin-top: 6px;
  padding: 6px 12px;
  border-radius: 12px;
  background: var(--ksk-primary-container);
  color: var(--ksk-primary);
  font-weight: 600;
}
.ksk-co__summary .ksk-co__bill-row--discount + .ksk-co__bill-row--discount {
  margin-top: 4px;
}
/* KSK118: the savings row sits between plain rows, so keep air below it too. */
.ksk-co__summary .ksk-co__bill-row--savings {
  margin-bottom: 6px;
}
.ksk-co__summary .ksk-co__bill-row--discount > span:first-child {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.ksk-co__summary .ksk-co__bill-row--discount .material-icons-round {
  font-size: 20px;
}
.ksk-co__summary .ksk-co__bill-row--discount > span:last-child {
  color: var(--ksk-primary);
  font-weight: 700;
}
.ksk-co__summary .ksk-co__bill-total {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 0;
}
.ksk-co__summary .ksk-co__bill-total-label {
  font-size: 24px;
}
.ksk-co__summary .ksk-co__bill-total-amount {
  font-size: 36px;
  line-height: 44px;
}
.ksk-co__applied,
.ksk-co__offer {
  display: flex;
  align-items: center;
  gap: var(--ksk-space-2);
  width: 100%;
  min-height: 64px;
  padding: 0 var(--ksk-space-2);
  border-radius: var(--ksk-radius-button);
  background: var(--ksk-surface-muted);
  font-family: var(--ksk-font);
  font-size: var(--ksk-body-size);
  color: var(--ksk-text);
}
.ksk-co__applied + .ksk-co__applied,
.ksk-co__applied + .ksk-co__offer,
.ksk-co__offer + .ksk-co__offer {
  margin-top: var(--ksk-space-1);
}
.ksk-co__applied {
  background: var(--ksk-primary-container);
}
.ksk-co__applied-icon {
  width: 40px;
  height: 40px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--ksk-primary);
  color: var(--ksk-on-primary);
  font-size: 24px;
}
.ksk-co__applied-text {
  flex: 1;
  min-width: 0;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ksk-co__remove {
  height: 48px;
  padding: 0 var(--ksk-space-3);
  border: 0;
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-surface);
  color: var(--ksk-error);
  font-family: var(--ksk-font);
  font-size: var(--ksk-caption-size);
  font-weight: 700;
  cursor: pointer;
}
.ksk-co__offer {
  border: 0;
  text-align: left;
  font-weight: 600;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.ksk-co__offer > .material-icons-round:first-child {
  font-size: 32px;
  color: var(--ksk-primary);
}
.ksk-co__offer-label {
  flex: 1;
}
.ksk-co__offer:active:not(:disabled) {
  transform: scale(0.99);
}
.ksk-co__offer:disabled {
  opacity: 0.5;
  cursor: default;
}
.ksk-co__count {
  min-width: 40px;
  height: 40px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-primary);
  color: var(--ksk-on-primary);
  font-size: var(--ksk-caption-size);
  font-weight: 700;
}
.ksk-co__chevron {
  font-size: 32px;
  color: var(--ksk-text-secondary);
}

.ksk-co__bill-row {
  display: flex;
  justify-content: space-between;
  gap: var(--ksk-space-2);
  padding: 4px 0;
  font-size: 20px;
  line-height: 28px;
  color: var(--ksk-text-secondary);
}
.ksk-co__bill-row > span:last-child {
  color: var(--ksk-text);
  font-weight: 600;
  text-align: right;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.ksk-co__bill-row > span.ksk-co__discount {
  color: var(--ksk-primary);
}
.ksk-co__bill-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: var(--ksk-space-2);
  padding-top: var(--ksk-space-2);
  border-top: 2px solid var(--ksk-border);
}
.ksk-co__bill-total-label {
  display: inline-flex;
  align-items: center;
  gap: var(--ksk-space-2);
  font-size: var(--ksk-item-size);
  font-weight: 700;
}
.ksk-co__items-badge {
  height: 36px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-surface-muted);
  color: var(--ksk-text-secondary);
  font-size: var(--ksk-caption-size);
  font-weight: 600;
}
.ksk-co__bill-total-amount {
  font-size: 40px;
  line-height: 48px;
  font-weight: 800;
  color: var(--ksk-primary);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.ksk-co__save {
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--ksk-space-2);
  margin-top: var(--ksk-space-2);
  padding: var(--ksk-space-2) var(--ksk-space-3);
  border: 1px solid var(--ksk-border);
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-primary-container);
  color: var(--ksk-text);
  font-family: var(--ksk-font);
  font-size: var(--ksk-body-size);
  line-height: var(--ksk-body-lh);
  text-align: left;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.ksk-co__save > .material-icons-round:first-child {
  font-size: 32px;
  color: var(--ksk-primary);
}
.ksk-co__save-text {
  flex: 1;
  min-width: 0;
}
.ksk-co__save strong {
  color: var(--ksk-primary);
  font-weight: 800;
  /* KSK119: the longer guest pill wraps - never between "$" and the amount. */
  white-space: nowrap;
}
.ksk-co__save:active {
  transform: scale(0.99);
}
.ksk-co__save--saved {
  cursor: default;
}
.ksk-co__save--saved:active {
  transform: none;
}

/* Sticky bottom bar (both modes). */
/* Fixed footer sheet: summary (non-retail) + Start Over / Payment. */
.footer.ksk-co__footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: var(--ksk-powered-height);
  width: 100%;
  padding: 0;
  z-index: 3;
  border-radius: 28px 28px 0 0;
  background: var(--ksk-surface);
  /* KSK125: short shadow hugging the top edge only, so it marks the sheet
     (even when tinted the same as the page) without washing the body. */
  box-shadow: 0 -2px 6px rgba(20, 26, 20, 0.08);
}
.ksk-co__bar {
  padding: var(--ksk-space-2) var(--ksk-space-3);
  border-radius: inherit;
  background: var(--ksk-surface);
  font-family: var(--ksk-font);
}
/* Under the summary, the buttons get their own band (light grey fill, no
   hairline — KSK058) so they read apart from the bill; Start Over turns
   white to stand out on it. */
.ksk-co__summary + .ksk-co__bar {
  padding: var(--ksk-space-2) var(--ksk-space-3) 20px;
  border-radius: 0;
  background: var(--ksk-background);
}
/* Start Over 1/3, Payment 2/3: fixed split, same height, even gap. */
.ksk-co__bar-main {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
  align-items: center;
  gap: var(--ksk-space-2);
}
.ksk-co__bar-main > * {
  width: 100%;
  min-width: 0;
}
/* KSK091: Start Over always red (error token), whatever the theme / colour
   slot; disabled (empty cart) keeps the red, just faded. */
.ksk-co__bar .ksk-co__start-over,
.ksk-co__bar .ksk-co__start-over:disabled {
  border-color: var(--ksk-error);
  background: var(--ksk-surface);
  color: var(--ksk-error);
}
.ksk-co__bar .ksk-co__start-over:disabled {
  opacity: 0.5;
}

/* KSK091: Start Over always dark red, whatever the theme / colour slot;
   disabled (empty cart) keeps the red, just faded. */
.ksk-co__bar .ksk-co__start-over,
.ksk-co__bar .ksk-co__start-over:disabled {
  border-color: var(--ksk-start-over-red);
  background: var(--ksk-surface);
  color: var(--ksk-start-over-red);
}
.ksk-co__bar .ksk-co__start-over:disabled {
  opacity: 0.5;
}

/* KSK091: Order More — pill floating just above the footer sheet; the scroll
   area keeps room for it (.ksk-co__scroll--more).
   KSK106: same size as Start Over (one third of the button row, md height)
   and a little higher above the sheet. */
.ksk-co__footer .ksk-co__more {
  position: absolute;
  bottom: calc(100% + var(--ksk-space-4));
  left: 50%;
  width: calc((100% - 2 * var(--ksk-space-3) - var(--ksk-space-2)) / 3);
  padding: 0 var(--ksk-space-2);
  transform: translateX(-50%);
  box-shadow: var(--ksk-shadow-card);
}
.ksk-co__footer .ksk-co__more:active:not(:disabled) {
  transform: translateX(-50%) scale(0.97);
}
.ksk-co__scroll--more {
  padding-bottom: calc(var(--ksk-space-4) + 80px + var(--ksk-space-4) + 28px);
}

/* ---------- KSK012: retail ---------- */
.ksk-co__staff {
  display: flex;
  align-items: center;
  gap: var(--ksk-space-2);
  padding: var(--ksk-space-2) var(--ksk-space-3);
  margin-bottom: var(--ksk-space-2);
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface-muted);
}
.ksk-co__staff-logo {
  width: 72px;
  height: 72px;
  flex: none;
  border-radius: 16px;
  object-fit: contain;
  background: var(--ksk-surface);
}
.ksk-co__staff-text {
  flex: 1;
  min-width: 0;
}
.ksk-co__scan {
  display: flex;
  align-items: center;
  gap: var(--ksk-space-2);
  height: 96px;
  margin: 0 0 var(--ksk-space-3);
  padding: 0 var(--ksk-space-3);
  border: 2px solid var(--ksk-border);
  border-radius: var(--ksk-radius-button);
  background: var(--ksk-surface);
  cursor: text;
}
.ksk-co__scan:focus-within {
  border-color: var(--ksk-primary);
  box-shadow: 0 0 0 4px var(--ksk-primary-container);
}
.ksk-co__scan > .material-icons-round {
  font-size: 40px;
  color: var(--ksk-primary);
}
.ksk-co__scan .ksk-co__scan-search {
  font-size: 32px;
  color: var(--ksk-text-secondary);
}
.ksk-co__scan .search-input {
  flex: 1;
  min-width: 0;
  height: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  font-family: var(--ksk-font);
  font-size: var(--ksk-body-size);
  color: var(--ksk-text);
  direction: ltr;
  text-align: left;
}
/* Global input::placeholder rules force 15px / centred / padded. */
.ksk-co__scan .search-input::placeholder {
  font-size: var(--ksk-body-size);
  font-weight: 400;
  padding-left: 0;
  color: var(--ksk-text-secondary);
}


/* ---------- Popular Add-Ons ---------- */
.ksk-co__addons-list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ksk-space-2);
  padding: 4px 0 8px;
}
/* Add-on tiles: two per row, wrapping onto further rows (KSK124; was one
   scrolling row of three, KSK086). Each one horizontal — square photo shown
   whole on the left, name + price on the right, round + on the tile's
   bottom-right corner (was on the photo, KSK076). */
.ksk-addon {
  position: relative;
  flex: 0 0 calc((100% - var(--ksk-space-2)) / 2);
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  grid-template-rows: auto auto;
  align-items: center;
  column-gap: 16px;
  row-gap: 4px;
  min-height: 136px;
  padding: 14px;
  border: 1px solid var(--ksk-border);
  border-radius: var(--ksk-radius-button);
  background: var(--ksk-surface);
  font-family: var(--ksk-font);
  text-align: left;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 80ms ease-out;
}
.ksk-addon:active {
  transform: scale(0.97);
}
/* The wrap holds the photo and the + (the + is pinned to the tile's corner). */
.ksk-addon__img-wrap {
  display: contents;
}
.ksk-addon__img {
  grid-column: 1;
  grid-row: 1 / span 2;
  display: block;
  width: 160px;
  height: 160px;
  border-radius: 14px;
  object-fit: cover;
  background: var(--ksk-surface-muted);
}
.ksk-addon__img--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 44px;
  color: var(--ksk-text-secondary);
}
.ksk-addon__plus {
  position: absolute;
  right: 14px;
  bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--ksk-primary);
  color: var(--ksk-on-primary);
  font-size: 30px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}
.ksk-addon__name {
  grid-column: 2;
  grid-row: 1;
  align-self: end;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 22px;
  line-height: 29px;
  font-weight: 600;
  color: var(--ksk-text);
}
.ksk-addon__price {
  grid-column: 2;
  grid-row: 2;
  align-self: start;
  /* Keep the price clear of the + in the corner. */
  padding-right: 60px;
  font-size: 22px;
  line-height: 29px;
  font-weight: 700;
  color: var(--ksk-primary);
  font-variant-numeric: tabular-nums;
}
</style>
